// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
/* General */
/* Menu */
/* Menu Dark*/
/* Menu Light*/
/* Topbar */
/* Footer */
.splash-screen {
  width: 100%;
  height: 100%;
  position: fixed;
  background: #FFFFFF;
  /* Old browsers */
  /* FF3.6+ */
  /* Chrome,Safari4+ */
  /* Chrome10+,Safari5.1+ */
  /* Opera 11.10+ */
  /* IE10+ */
  background: linear-gradient(to right, #FFFFFF 0%, #FFFFFF 100%);
  /* W3C */
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr=\$left, endColorstr=\$right,GradientType=1 );
  /* IE6-9 */ }
  .splash-screen .splash-container {
    width: 40px;
    height: 40px;
    margin: 0px auto;
    position: absolute;
    left: 50%;
    top: 50%;
    margin-left: -20px;
    margin-top: -20px; }
  .splash-screen .splash-double-bounce1, .splash-screen .splash-double-bounce2 {
    width: 100%;
    height: 100%;
    border-radius: 50%;
    background-color: #10497F;
    opacity: 0.6;
    position: absolute;
    top: 0;
    left: 0;
    animation: splash-bounce 2.0s infinite ease-in-out; }
  .splash-screen .splash-double-bounce2 {
    animation-delay: -1.0s; }

@keyframes splash-bounce {
  0%, 100% {
    transform: scale(0);
    -webkit-transform: scale(0); }
  50% {
    transform: scale(1);
    -webkit-transform: scale(1); } }

* {
  box-sizing: border-box; }

html {
  height: 100%; }

body {
  font-family: "Open Sans", "Helvetica Neue", sans-serif;
  font-size: 14px;
  color: #333333;
  background-color: #edf0f5;
  margin: 0;
  padding: 0;
  min-height: 100%; }

a {
  text-decoration: none; }

.layout-wrapper {
  padding: 0; }
  .layout-wrapper .layout-topbar {
    position: fixed;
    height: 50px;
    padding: .7em 1.5em 0em 1.5em;
    box-shadow: 0px 2px 6px rgba(0, 0, 0, 0.2);
    color: #ffffff;
    z-index: 999;
    right: 0;
    background: #FFFFFF;
    /* Old browsers */
    /* FF3.6+ */
    /* Chrome,Safari4+ */
    /* Chrome10+,Safari5.1+ */
    /* Opera 11.10+ */
    /* IE10+ */
    background: linear-gradient(to right, #FFFFFF 0%, #FFFFFF 100%);
    /* W3C */
    filter: progid:DXImageTransform.Microsoft.gradient( startColorstr=\$left, endColorstr=\$right,GradientType=1 );
    /* IE6-9 */
    transition: left 0.2s; }
    .layout-wrapper .layout-topbar .layout-topbar-icons {
      float: right;
      display: block;
      animation-duration: .5s; }
      .layout-wrapper .layout-topbar .layout-topbar-icons button {
        position: relative;
        color: #10497F;
        margin-left: 20px;
        display: inline-block;
        text-decoration: none;
        transition: color 0.2s; }
        .layout-wrapper .layout-topbar .layout-topbar-icons button:hover {
          color: #77c7ff; }
        .layout-wrapper .layout-topbar .layout-topbar-icons button span.layout-topbar-icon {
          font-size: 2em; }
        .layout-wrapper .layout-topbar .layout-topbar-icons button span.layout-topbar-item-text {
          font-size: 20px;
          display: none; }
        .layout-wrapper .layout-topbar .layout-topbar-icons button span.layout-topbar-badge {
          position: absolute;
          font-size: 10px;
          right: -5px;
          top: -5px;
          width: 16px;
          height: 16px;
          text-align: center;
          line-height: 16px;
          color: #FFFFFF;
          background-color: #6D9BC7;
          border-radius: 50%; }
    .layout-wrapper .layout-topbar .layout-topbar-search {
      padding: 0;
      position: relative;
      display: inline-block;
      top: -4px;
      margin-left: 30px; }
      .layout-wrapper .layout-topbar .layout-topbar-search input {
        display: inline-block;
        border: 0 none;
        font-size: 14px;
        background: transparent;
        border-bottom: 2px solid #10497F;
        outline: 0 none;
        box-shadow: none;
        color: #10497F;
        width: 300px;
        padding: 1px 20px 1px 35px;
        margin: 0px;
        border-radius: 2px; }
        .layout-wrapper .layout-topbar .layout-topbar-search input::-webkit-input-placeholder {
          color: #10497F;
          opacity: .7;
          -webkit-transition: opacity 0.2s;
          transition: opacity 0.2s; }
        .layout-wrapper .layout-topbar .layout-topbar-search input:-moz-placeholder {
          color: #10497F;
          opacity: .7;
          -moz-transition: opacity 0.2s;
          transition: opacity 0.2s; }
        .layout-wrapper .layout-topbar .layout-topbar-search input::-moz-placeholder {
          color: #10497F;
          opacity: .7;
          -moz-transition: opacity 0.2s;
          transition: opacity 0.2s; }
        .layout-wrapper .layout-topbar .layout-topbar-search input:-ms-input-placeholder {
          color: #10497F;
          opacity: .7;
          -ms-transition: opacity 0.2s;
          transition: opacity 0.2s; }
      .layout-wrapper .layout-topbar .layout-topbar-search .layout-topbar-search-icon {
        font-size: 18px;
        position: absolute;
        top: -1px;
        left: 0px;
        color: #10497F; }
      .layout-wrapper .layout-topbar .layout-topbar-search:hover input {
        border-bottom-color: #77c7ff; }
        .layout-wrapper .layout-topbar .layout-topbar-search:hover input::-webkit-input-placeholder {
          opacity: 1; }
        .layout-wrapper .layout-topbar .layout-topbar-search:hover input:-moz-placeholder {
          opacity: 1; }
        .layout-wrapper .layout-topbar .layout-topbar-search:hover input::-moz-placeholder {
          opacity: 1; }
        .layout-wrapper .layout-topbar .layout-topbar-search:hover input:-ms-input-placeholder {
          opacity: 1; }
      .layout-wrapper .layout-topbar .layout-topbar-search:hover .layout-topbar-search-icon {
        color: #77c7ff; }
    .layout-wrapper .layout-topbar .layout-menu-button {
      cursor: pointer;
      display: inline-block;
      text-decoration: none;
      color: #10497F;
      transition: color 0.2s; }
      .layout-wrapper .layout-topbar .layout-menu-button span {
        font-size: 2em; }
      .layout-wrapper .layout-topbar .layout-menu-button:hover {
        color: #77c7ff; }
    .layout-wrapper .layout-topbar button {
      cursor: pointer; }
  .layout-wrapper .p-scrollpanel {
    background: transparent;
    border-radius: 0;
    border: none; }
    .layout-wrapper .p-scrollpanel .p-scrollpanel-content {
      overflow: scroll; }
    .layout-wrapper .p-scrollpanel .p-scrollpanel-bar {
      background: #aaaaaa;
      opacity: 0.3;
      filter: alpha(opacity=30); }
    .layout-wrapper .p-scrollpanel .p-scrollpanel-hidden {
      display: block;
      visibility: hidden; }
    .layout-wrapper .p-scrollpanel .layout-sidebar-scroll-content {
      width: calc(100% + 18px);
      padding-bottom: 120px; }
  .layout-wrapper .layout-sidebar {
    position: fixed;
    width: 250px;
    height: 100%;
    z-index: 999;
    user-select: none;
    -moz-user-select: none;
    -webkit-user-select: none;
    transition: left 0.2s;
    background: #f3f4f9;
    /* Old browsers */
    /* FF3.6+ */
    /* Chrome,Safari4+ */
    /* Chrome10+,Safari5.1+ */
    /* Opera 11.10+ */
    /* IE10+ */
    background: linear-gradient(to bottom, #f3f4f9 0%, #d7dbe8 100%);
    /* W3C */
    filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#ffffff', endColorstr='#000000',GradientType=0 );
    /* IE6-9 */
    box-shadow: 0 0 6px 0 rgba(0, 0, 0, 0.16); }
    .layout-wrapper .layout-sidebar .logo-title {
      color: #ffffff;
      font-size: 20px; }
    .layout-wrapper .layout-sidebar .layout-logo {
      text-align: center;
      margin-top: 24px; }
    .layout-wrapper .layout-sidebar .profile {
      text-align: center;
      padding: 20px 0; }
      .layout-wrapper .layout-sidebar .profile img {
        width: 56px;
        margin: 10px; }
      .layout-wrapper .layout-sidebar .profile .profile-link {
        cursor: pointer;
        color: #232428;
        display: inline-block;
        margin-bottom: 10px;
        transition: color 0.2s; }
        .layout-wrapper .layout-sidebar .profile .profile-link i {
          display: inline-block;
          font-size: 16px;
          vertical-align: middle; }
        .layout-wrapper .layout-sidebar .profile .profile-link:hover {
          color: #0388e5; }
      .layout-wrapper .layout-sidebar .profile > ul {
        overflow: hidden;
        background-color: #ffffff;
        text-align: left;
        max-height: 0;
        transition-duration: 0.2s;
        transition-timing-function: cubic-bezier(0.86, 0, 0.07, 1); }
        .layout-wrapper .layout-sidebar .profile > ul.profile-expanded {
          max-height: 500px; }
        .layout-wrapper .layout-sidebar .profile > ul li button {
          width: 100%;
          padding: 1em 15px 1em 1em;
          border: 0 none;
          border-radius: 0; }
          .layout-wrapper .layout-sidebar .profile > ul li button:hover {
            color: #0388e5; }
          .layout-wrapper .layout-sidebar .profile > ul li button span {
            margin-left: .25em;
            vertical-align: middle; }
          .layout-wrapper .layout-sidebar .profile > ul li button i {
            vertical-align: middle; }
        .layout-wrapper .layout-sidebar .profile > ul li:last-child > button {
          border: 0 none; }
    .layout-wrapper .layout-sidebar ul {
      list-style-type: none;
      margin: 0;
      padding: 0; }
      .layout-wrapper .layout-sidebar ul li a {
        cursor: pointer;
        position: relative;
        color: #232428;
        text-decoration: none;
        font-size: 14px;
        padding: 1em 15px 1em 1em;
        display: block;
        border-top: 1px solid rgba(207, 211, 224, 0.6); }
        .layout-wrapper .layout-sidebar ul li a i {
          font-size: 18px;
          vertical-align: middle; }
        .layout-wrapper .layout-sidebar ul li a span {
          margin-left: .25em;
          vertical-align: middle; }
        .layout-wrapper .layout-sidebar ul li a .menuitem-toggle-icon {
          float: right; }
        .layout-wrapper .layout-sidebar ul li a:hover {
          color: #0388e5; }
        .layout-wrapper .layout-sidebar ul li a.active-route {
          background-color: #ffffff;
          color: #0388e5; }
          .layout-wrapper .layout-sidebar ul li a.active-route .menuitem-toggle-icon:before {
            content: ""; }
      .layout-wrapper .layout-sidebar ul li.active-menuitem > a {
        background-color: #ffffff;
        color: #0388e5; }
        .layout-wrapper .layout-sidebar ul li.active-menuitem > a .menuitem-toggle-icon:before {
          content: ""; }
      .layout-wrapper .layout-sidebar ul li.active-menuitem > ul {
        max-height: 500px; }
      .layout-wrapper .layout-sidebar ul li ul {
        background-color: #ffffff;
        overflow: hidden;
        padding-left: 1.5em;
        max-height: 0;
        transition-property: max-height;
        transition-duration: 0.4s;
        transition-timing-function: cubic-bezier(0.86, 0, 0.07, 1); }
        .layout-wrapper .layout-sidebar ul li ul li a {
          cursor: pointer;
          padding: .75em 33px .75em .75em;
          font-size: 13px;
          border-top: 0 none; }
        .layout-wrapper .layout-sidebar ul li ul li:last-child > a {
          border-bottom: 0 none; }
      .layout-wrapper .layout-sidebar ul .menuitem-toggle-icon {
        float: right;
        margin-top: 2px; }
      .layout-wrapper .layout-sidebar ul .menuitem-badge {
        margin-top: 3px;
        font-size: 10px;
        float: right;
        width: 16px;
        height: 16px;
        line-height: 16px;
        text-align: center;
        color: #ffffff;
        background-color: #007be5;
        border-radius: 50%; }
    .layout-wrapper .layout-sidebar.layout-sidebar-dark {
      background: #10497F;
      /* Old browsers */
      /* FF3.6+ */
      /* Chrome,Safari4+ */
      /* Chrome10+,Safari5.1+ */
      /* Opera 11.10+ */
      /* IE10+ */
      background: linear-gradient(to bottom, #10497F 0%, #10497F 100%);
      /* W3C */
      filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#ffffff', endColorstr='#000000',GradientType=0 );
      /* IE6-9 */ }
      .layout-wrapper .layout-sidebar.layout-sidebar-dark .profile > button {
        color: #ffffff; }
        .layout-wrapper .layout-sidebar.layout-sidebar-dark .profile > button:hover {
          color: #F0AD4E; }
      .layout-wrapper .layout-sidebar.layout-sidebar-dark .profile > ul {
        background-color: #6D9BC7; }
        .layout-wrapper .layout-sidebar.layout-sidebar-dark .profile > ul li button {
          border: 0 none;
          color: #ffffff;
          border-top: 1px solid rgba(52, 56, 65, 0.6); }
          .layout-wrapper .layout-sidebar.layout-sidebar-dark .profile > ul li button:hover {
            color: #F0AD4E; }
      .layout-wrapper .layout-sidebar.layout-sidebar-dark ul li a {
        color: #ffffff;
        border-top: 1px solid rgba(52, 56, 65, 0.6); }
        .layout-wrapper .layout-sidebar.layout-sidebar-dark ul li a:hover {
          color: #F0AD4E; }
        .layout-wrapper .layout-sidebar.layout-sidebar-dark ul li a.active-route {
          background-color: #597FA2;
          color: #F0AD4E; }
      .layout-wrapper .layout-sidebar.layout-sidebar-dark ul li.active-menuitem > a {
        background-color: #6D9BC7;
        color: #F0AD4E; }
      .layout-wrapper .layout-sidebar.layout-sidebar-dark ul li ul {
        background-color: #597FA2; }
        .layout-wrapper .layout-sidebar.layout-sidebar-dark ul li ul li a {
          border: none; }
        .layout-wrapper .layout-sidebar.layout-sidebar-dark ul li ul li.active-menuitem > a {
          background-color: #597FA2;
          color: #F0AD4E; }
  .layout-wrapper .layout-main {
    transition: margin-left 0.2s;
    padding: 66px 16px 16px 16px; }
  .layout-wrapper .layout-footer {
    transition: margin-left 0.2s;
    background-color: #ffffff;
    padding: 1em 2em; }
    .layout-wrapper .layout-footer img {
      vertical-align: middle; }
    .layout-wrapper .layout-footer .footer-text {
      vertical-align: middle; }

/* Responsive */
@media (min-width: 1025px) {
  .layout-wrapper.layout-overlay .layout-sidebar {
    left: -250px; }
  .layout-wrapper.layout-overlay .layout-topbar {
    left: 0; }
  .layout-wrapper.layout-overlay .layout-main, .layout-wrapper.layout-overlay .layout-footer {
    margin-left: 0; }
  .layout-wrapper.layout-overlay.layout-overlay-sidebar-active .layout-sidebar {
    left: 0; }
  .layout-wrapper.layout-overlay.layout-overlay-sidebar-active .layout-topbar {
    left: 250px; }
  .layout-wrapper.layout-static .layout-sidebar {
    left: 0; }
  .layout-wrapper.layout-static .layout-topbar {
    left: 250px; }
  .layout-wrapper.layout-static .layout-main, .layout-wrapper.layout-static .layout-footer {
    margin-left: 250px; }
  .layout-wrapper.layout-static.layout-static-sidebar-inactive .layout-sidebar {
    left: -250px; }
  .layout-wrapper.layout-static.layout-static-sidebar-inactive .layout-topbar {
    left: 0; }
  .layout-wrapper.layout-static.layout-static-sidebar-inactive .layout-main, .layout-wrapper.layout-static.layout-static-sidebar-inactive .layout-footer {
    margin-left: 0; } }

@media (max-width: 1024px) {
  .layout-wrapper .layout-topbar {
    left: 0; }
  .layout-wrapper .layout-main, .layout-wrapper .layout-footer {
    margin-left: 0; }
  .layout-wrapper .layout-sidebar {
    left: -250px;
    margin-top: 50px; }
  .layout-wrapper .layout-mask {
    display: none;
    position: fixed;
    width: 100%;
    height: 100%;
    top: 50px;
    left: 0;
    z-index: 998;
    background-color: #424242;
    opacity: 0.7;
    filter: alpha(opacity=70); }
  .layout-wrapper.layout-mobile-sidebar-active .layout-sidebar {
    left: -0; }
  .layout-wrapper.layout-mobile-sidebar-active .layout-mask {
    display: block; }
  .body-overflow-hidden {
    overflow: hidden; } }

/* Typography */
h1 {
  font-weight: normal;
  margin: 0;
  font-size: 24px; }

h2 {
  font-size: 20px;
  font-weight: normal;
  margin: 0; }

.card {
  background-color: #ffffff;
  padding: 1em;
  margin-bottom: 16px;
  border-radius: 3px; }
  .card.card-w-title {
    padding-bottom: 2em; }
  .card h1 {
    margin: .5em 0 .5em 0;
    border-bottom: 1px solid #d5d5d5;
    padding: .1em;
    font-size: 24px; }
    .card h1:first-child {
      margin: 0 0 .5em 0; }

.p-g {
  -ms-flex-wrap: wrap; }

/* Dashboard */
.dashboard .summary {
  position: relative;
  flex-direction: row; }
  .dashboard .summary .title {
    font-size: 34px;
    font-weight: 700;
    text-align: center; }
  .dashboard .summary .detail {
    color: #707070;
    display: block;
    margin-top: 5px; }
  .dashboard .summary .count {
    top: 30px;
    right: 10px;
    font-size: 24px;
    text-align: center; }
    .dashboard .summary .count .detail {
      color: #ffffff;
      padding: 7px 14px;
      border-radius: 3px; }
    .dashboard .summary .count .trust1 {
      background-color: #5CB85C; }
    .dashboard .summary .count .over65 {
      background-color: #10497F; }
    .dashboard .summary .count .friends {
      background-color: #F0AD4E; }

.dashboard .highlight-box {
  height: 100px; }
  .dashboard .highlight-box:after {
    content: "";
    display: table;
    clear: both; }
  .dashboard .highlight-box .initials {
    height: 100%;
    float: left;
    width: 50%;
    text-align: center;
    padding: 1em; }
    .dashboard .highlight-box .initials > span {
      font-size: 48px; }
  .dashboard .highlight-box .highlight-details {
    height: 100%;
    background-color: #ffffff;
    float: left;
    width: 50%;
    padding: 1em; }
    .dashboard .highlight-box .highlight-details i {
      font-size: 24px;
      vertical-align: middle;
      margin-right: .25em; }
    .dashboard .highlight-box .highlight-details .count {
      color: #707070;
      font-size: 36px;
      display: block; }

.dashboard .task-list {
  list-style-type: none;
  margin: 0;
  padding: 0; }
  .dashboard .task-list li {
    padding: .5em .25em;
    border-bottom: 1px solid #e3e3e3; }
    .dashboard .task-list li:after {
      content: "";
      display: table;
      clear: both; }
  .dashboard .task-list .p-checkbox {
    vertical-align: middle;
    margin-right: .5em; }
  .dashboard .task-list .task-name {
    vertical-align: middle; }
  .dashboard .task-list .p-button {
    float: right; }
    .dashboard .task-list .p-button .p-button-text {
      padding: .125em; }
  .dashboard .task-list .p-panel-content {
    min-height: 256px; }

.dashboard .contact-form .p-panel-content {
  min-height: 256px; }

.dashboard .contacts ul {
  list-style-type: none;
  padding: 0;
  margin: 0; }
  .dashboard .contacts ul li {
    border-bottom: 1px solid #e3e3e3; }
    .dashboard .contacts ul li button {
      padding: 9px;
      width: 100%;
      box-sizing: border-box;
      text-decoration: none;
      position: relative;
      display: block;
      border-radius: 2px;
      transition: background-color 0.2s; }
      .dashboard .contacts ul li button .name {
        position: absolute;
        right: 10px;
        top: 10px;
        font-size: 18px; }
      .dashboard .contacts ul li button .email {
        position: absolute;
        right: 10px;
        top: 30px;
        font-size: 14px;
        color: #707070; }
      .dashboard .contacts ul li button:hover {
        cursor: pointer;
        background-color: #eeeeee; }
    .dashboard .contacts ul li:last-child {
      border: 0; }

.dashboard .contacts .p-panel-content {
  min-height: 256px; }

.dashboard .activity-list {
  list-style-type: none;
  padding: 0;
  margin: 0; }
  .dashboard .activity-list li {
    border-bottom: 1px solid #e3e3e3;
    padding: 16px 8px; }
    .dashboard .activity-list li .count {
      font-size: 24px;
      color: #ffffff;
      background-color: #007be5;
      font-weight: 700;
      display: inline-block;
      padding: .25em .5em;
      border-radius: 3px; }
    .dashboard .activity-list li:first-child {
      border-top: 1px solid #e3e3e3; }
    .dashboard .activity-list li:last-child {
      border: 0; }
    .dashboard .activity-list li .p-g-6:first-child {
      font-size: 18px;
      padding-left: 0; }
    .dashboard .activity-list li .p-g-6:last-child {
      text-align: right;
      color: #707070; }

/*!
 * Quill Editor v1.0.0-beta.3
 * https://quilljs.com/
 * Copyright (c) 2014, Jason Chen
 * Copyright (c) 2013, salesforce.com
 */
.ql-container {
  box-sizing: border-box;
  font-family: Helvetica, Arial, sans-serif;
  font-size: 13px;
  height: 100%;
  margin: 0px;
  position: relative; }

.ql-clipboard {
  left: -100000px;
  position: absolute;
  top: 50%; }

.ql-clipboard p {
  margin: 0;
  padding: 0; }

.ql-editor {
  box-sizing: border-box;
  cursor: text;
  line-height: 1.42;
  height: 100%;
  outline: none;
  overflow-y: auto;
  padding: 12px 15px;
  tab-size: 4;
  text-align: left;
  white-space: pre-wrap; }

.ql-editor p,
.ql-editor ol,
.ql-editor ul,
.ql-editor pre,
.ql-editor blockquote,
.ql-editor h1,
.ql-editor h2,
.ql-editor h3,
.ql-editor h4,
.ql-editor h5,
.ql-editor h6 {
  margin: 0;
  padding: 0;
  counter-reset: list-1 list-2 list-3 list-4 list-5 list-6 list-7 list-8; }

.ql-editor ol {
  padding-left: 20px; }

.ql-editor ul {
  padding-left: 8px;
  list-style: disc inside; }

.ql-editor ol > li {
  list-style-type: none; }

.ql-editor ol {
  list-style-type: none;
  position: relative; }

.ql-editor ol li {
  counter-reset: list-1 list-2 list-3 list-4 list-5 list-6 list-7 list-8;
  counter-increment: list-num; }

.ql-editor ol li:before {
  content: counter(list-num, decimal) ". ";
  margin-right: -16px;
  position: absolute;
  right: 100%;
  text-align: right; }

.ql-editor ol li.ql-indent-1 {
  counter-increment: list-1; }

.ql-editor ol li.ql-indent-1:before {
  content: counter(list-1, lower-alpha) ". ";
  margin-right: -56px; }

.ql-editor ol li.ql-indent-1 {
  counter-reset: list-2 list-3 list-4 list-5 list-6 list-7 list-8; }

.ql-editor ol li.ql-indent-2 {
  counter-increment: list-2; }

.ql-editor ol li.ql-indent-2:before {
  content: counter(list-2, lower-roman) ". ";
  margin-right: -96px; }

.ql-editor ol li.ql-indent-2 {
  counter-reset: list-3 list-4 list-5 list-6 list-7 list-8; }

.ql-editor ol li.ql-indent-3 {
  counter-increment: list-3; }

.ql-editor ol li.ql-indent-3:before {
  content: counter(list-3, decimal) ". ";
  margin-right: -136px; }

.ql-editor ol li.ql-indent-3 {
  counter-reset: list-4 list-5 list-6 list-7 list-8; }

.ql-editor ol li.ql-indent-4 {
  counter-increment: list-4; }

.ql-editor ol li.ql-indent-4:before {
  content: counter(list-4, lower-alpha) ". ";
  margin-right: -176px; }

.ql-editor ol li.ql-indent-4 {
  counter-reset: list-5 list-6 list-7 list-8; }

.ql-editor ol li.ql-indent-5 {
  counter-increment: list-5; }

.ql-editor ol li.ql-indent-5:before {
  content: counter(list-5, lower-roman) ". ";
  margin-right: -216px; }

.ql-editor ol li.ql-indent-5 {
  counter-reset: list-6 list-7 list-8; }

.ql-editor ol li.ql-indent-6 {
  counter-increment: list-6; }

.ql-editor ol li.ql-indent-6:before {
  content: counter(list-6, decimal) ". ";
  margin-right: -256px; }

.ql-editor ol li.ql-indent-6 {
  counter-reset: list-7 list-8; }

.ql-editor ol li.ql-indent-7 {
  counter-increment: list-7; }

.ql-editor ol li.ql-indent-7:before {
  content: counter(list-7, lower-alpha) ". ";
  margin-right: -296px; }

.ql-editor ol li.ql-indent-7 {
  counter-reset: list-8; }

.ql-editor ol li.ql-indent-8 {
  counter-increment: list-8; }

.ql-editor ol li.ql-indent-8:before {
  content: counter(list-8, lower-roman) ". ";
  margin-right: -336px; }

.ql-editor .ql-indent-1 {
  padding-left: 40px; }

.ql-editor .ql-indent-2 {
  padding-left: 80px; }

.ql-editor .ql-indent-3 {
  padding-left: 120px; }

.ql-editor .ql-indent-4 {
  padding-left: 160px; }

.ql-editor .ql-indent-5 {
  padding-left: 200px; }

.ql-editor .ql-indent-6 {
  padding-left: 240px; }

.ql-editor .ql-indent-7 {
  padding-left: 280px; }

.ql-editor .ql-indent-8 {
  padding-left: 320px; }

.ql-editor .ql-video {
  display: block; }

.ql-editor .ql-video.ql-align-center {
  margin: 0 auto; }

.ql-editor .ql-video.ql-align-right {
  margin: 0 0 0 auto; }

.ql-editor .ql-bg-black {
  background-color: #000; }

.ql-editor .ql-bg-red {
  background-color: #e60000; }

.ql-editor .ql-bg-orange {
  background-color: #f90; }

.ql-editor .ql-bg-yellow {
  background-color: #ff0; }

.ql-editor .ql-bg-green {
  background-color: #008a00; }

.ql-editor .ql-bg-blue {
  background-color: #06c; }

.ql-editor .ql-bg-purple {
  background-color: #93f; }

.ql-editor .ql-color-white {
  color: #fff; }

.ql-editor .ql-color-red {
  color: #e60000; }

.ql-editor .ql-color-orange {
  color: #f90; }

.ql-editor .ql-color-yellow {
  color: #ff0; }

.ql-editor .ql-color-green {
  color: #008a00; }

.ql-editor .ql-color-blue {
  color: #06c; }

.ql-editor .ql-color-purple {
  color: #93f; }

.ql-editor .ql-font-serif {
  font-family: Georgia, Times New Roman, serif; }

.ql-editor .ql-font-monospace {
  font-family: Monaco, Courier New, monospace; }

.ql-editor .ql-size-small {
  font-size: 10px; }

.ql-editor .ql-size-large {
  font-size: 18px; }

.ql-editor .ql-size-huge {
  font-size: 32px; }

.ql-editor .ql-direction-rtl {
  direction: rtl;
  text-align: inherit; }

.ql-editor .ql-align-center {
  text-align: center; }

.ql-editor .ql-align-justify {
  text-align: justify; }

.ql-editor .ql-align-right {
  text-align: right; }

.ql-editor.ql-blank::before {
  color: rgba(0, 0, 0, 0.6);
  content: attr(data-placeholder);
  font-style: italic;
  pointer-events: none;
  position: absolute; }

.ql-hidden {
  display: none; }

.ql-tooltip {
  position: absolute; }

.ql-tooltip a {
  cursor: pointer;
  text-decoration: none; }

.ql-toolbar:before,
.ql-toolbar:after {
  content: ' ';
  display: table; }

.ql-toolbar:after {
  clear: both; }

.ql-toolbar button {
  background: none;
  border: none;
  cursor: pointer;
  display: inline-block;
  float: left;
  height: 24px;
  outline: none;
  padding: 3px 5px;
  width: 24px; }

.ql-toolbar button svg {
  height: 100%; }

.ql-toolbar .ql-stroke {
  fill: none;
  stroke-linecap: round;
  stroke-linejoin: round;
  stroke-width: 2; }

.ql-toolbar .ql-stroke-mitter {
  fill: none;
  stroke-mitterlimit: 10;
  stroke-width: 2; }

.ql-toolbar .ql-empty {
  fill: none; }

.ql-toolbar .ql-even {
  fill-rule: evenodd; }

.ql-toolbar .ql-thin,
.ql-toolbar .ql-stroke.ql-thin {
  stroke-width: 1; }

.ql-toolbar .ql-transparent {
  opacity: 0.4; }

.ql-editor h1 {
  font-size: 2em; }

.ql-editor h2 {
  font-size: 1.5em; }

.ql-editor h3 {
  font-size: 1.17em; }

.ql-editor h4 {
  font-size: 1em; }

.ql-editor h5 {
  font-size: 0.83em; }

.ql-editor h6 {
  font-size: 0.67em; }

.ql-editor pre {
  white-space: pre-wrap; }

.ql-editor a {
  text-decoration: underline; }

.ql-editor blockquote {
  border-left: 4px solid #ccc;
  margin-bottom: 5px;
  margin-top: 5px;
  padding-left: 16px; }

.ql-editor pre.hljs {
  overflow: visible; }

.ql-editor code,
.ql-editor pre:not(.hljs) {
  background-color: #f0f0f0; }

.ql-editor code,
.ql-editor pre {
  border-radius: 3px; }

.ql-editor code {
  font-size: 85%;
  padding-bottom: 2px;
  padding-top: 2px; }

.ql-editor code:before,
.ql-editor code:after {
  content: "\\A0";
  letter-spacing: -2px; }

.ql-editor *:not(pre) + pre,
.ql-editor pre:first-of-type {
  margin-top: 5px;
  padding-top: 5px; }

.ql-editor pre {
  margin-bottom: 5px;
  padding: 0px 10px 5px; }

.ql-editor pre + pre {
  margin-top: -10px; }

.ql-editor img {
  max-width: 100%; }

.ql-snow .ql-image-tooltip {
  padding: 10px;
  text-align: center;
  width: 300px; }

.ql-snow .ql-image-tooltip input[type=text] {
  height: 30px;
  width: 100%; }

.ql-snow .ql-image-tooltip a.ql-cancel,
.ql-snow .ql-image-tooltip a.ql-action {
  border: 1px solid #06c;
  display: inline-block;
  float: left;
  line-height: 18px;
  padding: 5px;
  width: 50%; }

.ql-snow .ql-image-tooltip a.ql-cancel::before {
  color: #06c;
  content: 'Cancel'; }

.ql-snow .ql-image-tooltip a.ql-action {
  background-color: #06c; }

.ql-snow .ql-image-tooltip a.ql-action::before {
  color: #fff;
  content: 'Insert'; }

.ql-snow .ql-image-tooltip .ql-preview {
  height: 200px;
  margin: 10px 0px;
  position: relative; }

.ql-snow .ql-image-tooltip .ql-preview img {
  bottom: 0;
  left: 0;
  margin: auto;
  max-height: 100%;
  max-width: 100%;
  position: absolute;
  right: 0;
  top: 0; }

.ql-snow .ql-image-tooltip .ql-empty.ql-preview::before {
  border: 1px dashed #ccc;
  color: #ccc;
  content: 'Preview';
  display: block;
  line-height: 200px; }

.ql-snow .ql-link-tooltip::before {
  content: "Visit URL:";
  line-height: 26px;
  margin-right: 8px; }

.ql-snow .ql-link-tooltip {
  margin-top: 10px;
  padding: 5px 12px;
  white-space: nowrap; }

.ql-snow .ql-link-tooltip input[type=text] {
  display: none;
  height: 26px;
  width: 170px; }

.ql-snow .ql-link-tooltip a.ql-preview {
  display: inline-block;
  max-width: 200px;
  overflow-x: hidden;
  text-overflow: ellipsis;
  vertical-align: top; }

.ql-snow .ql-link-tooltip a.ql-action::before {
  color: #444;
  content: '-';
  line-height: 26px;
  margin-left: 8px; }

.ql-snow .ql-link-tooltip a.ql-action::after {
  border-right: 1px solid #ccc;
  content: 'Edit';
  margin-left: 8px;
  padding-right: 8px; }

.ql-snow .ql-link-tooltip a.ql-remove::before {
  content: 'Remove';
  margin-left: 8px; }

.ql-snow .ql-link-tooltip a {
  line-height: 26px; }

.ql-snow .ql-link-tooltip.ql-editing a.ql-preview,
.ql-snow .ql-link-tooltip.ql-editing a.ql-remove {
  display: none; }

.ql-snow .ql-link-tooltip.ql-editing input[type=text] {
  display: inline-block; }

.ql-snow .ql-link-tooltip.ql-editing a.ql-action::after {
  border-right: 0px;
  content: 'Save';
  padding-right: 0px; }

.ql-toolbar.ql-snow {
  border: 1px solid #ccc;
  box-sizing: border-box;
  font-family: 'Helvetica Neue', 'Helvetica', 'Arial', sans-serif;
  padding: 8px; }

.ql-toolbar.ql-snow * {
  box-sizing: border-box; }

.ql-toolbar.ql-snow .ql-formats {
  display: inline-block;
  margin-right: 15px;
  vertical-align: middle; }

.ql-toolbar.ql-snow button:hover,
.ql-toolbar.ql-snow button.ql-active,
.ql-toolbar.ql-snow .ql-picker-label:hover,
.ql-toolbar.ql-snow .ql-picker-label.ql-active,
.ql-toolbar.ql-snow .ql-picker-item:hover,
.ql-toolbar.ql-snow .ql-picker-item.ql-selected {
  color: #06c; }

.ql-toolbar.ql-snow button:hover .ql-fill,
.ql-toolbar.ql-snow button.ql-active .ql-fill,
.ql-toolbar.ql-snow .ql-picker-label:hover .ql-fill,
.ql-toolbar.ql-snow .ql-picker-label.ql-active .ql-fill,
.ql-toolbar.ql-snow .ql-picker-item:hover .ql-fill,
.ql-toolbar.ql-snow .ql-picker-item.ql-selected .ql-fill,
.ql-toolbar.ql-snow button:hover .ql-stroke.ql-fill,
.ql-toolbar.ql-snow button.ql-active .ql-stroke.ql-fill,
.ql-toolbar.ql-snow .ql-picker-label:hover .ql-stroke.ql-fill,
.ql-toolbar.ql-snow .ql-picker-label.ql-active .ql-stroke.ql-fill,
.ql-toolbar.ql-snow .ql-picker-item:hover .ql-stroke.ql-fill,
.ql-toolbar.ql-snow .ql-picker-item.ql-selected .ql-stroke.ql-fill {
  fill: #06c; }

.ql-toolbar.ql-snow button:hover .ql-stroke,
.ql-toolbar.ql-snow button.ql-active .ql-stroke,
.ql-toolbar.ql-snow .ql-picker-label:hover .ql-stroke,
.ql-toolbar.ql-snow .ql-picker-label.ql-active .ql-stroke,
.ql-toolbar.ql-snow .ql-picker-item:hover .ql-stroke,
.ql-toolbar.ql-snow .ql-picker-item.ql-selected .ql-stroke,
.ql-toolbar.ql-snow button:hover .ql-stroke-mitter,
.ql-toolbar.ql-snow button.ql-active .ql-stroke-mitter,
.ql-toolbar.ql-snow .ql-picker-label:hover .ql-stroke-mitter,
.ql-toolbar.ql-snow .ql-picker-label.ql-active .ql-stroke-mitter,
.ql-toolbar.ql-snow .ql-picker-item:hover .ql-stroke-mitter,
.ql-toolbar.ql-snow .ql-picker-item.ql-selected .ql-stroke-mitter {
  stroke: #06c; }

.ql-toolbar.ql-snow .ql-stroke {
  stroke: #444; }

.ql-toolbar.ql-snow .ql-stroke-mitter {
  stroke: #444; }

.ql-toolbar.ql-snow .ql-fill,
.ql-toolbar.ql-snow .ql-stroke.ql-fill {
  fill: #444; }

.ql-toolbar.ql-snow .ql-direction svg:last-child {
  display: none; }

.ql-toolbar.ql-snow .ql-direction.ql-active svg:last-child {
  display: inline; }

.ql-toolbar.ql-snow .ql-direction.ql-active svg:first-child {
  display: none; }

.ql-toolbar.ql-snow .ql-picker {
  color: #444;
  display: inline-block;
  float: left;
  font-size: 14px;
  font-weight: 500;
  height: 24px;
  position: relative;
  vertical-align: middle; }

.ql-toolbar.ql-snow .ql-picker-label {
  border: 1px solid transparent;
  cursor: pointer;
  display: inline-block;
  height: 100%;
  padding-left: 8px;
  padding-right: 2px;
  position: relative;
  width: 100%; }

.ql-toolbar.ql-snow .ql-picker-label svg {
  float: right;
  height: 18px;
  margin-top: 2px;
  width: 18px; }

.ql-toolbar.ql-snow .ql-picker-label::before {
  vertical-align: middle; }

.ql-toolbar.ql-snow .ql-picker-options {
  background-color: #fff;
  border: 1px solid transparent;
  display: none;
  min-width: 100%;
  padding: 4px 8px;
  position: absolute;
  white-space: nowrap; }

.ql-toolbar.ql-snow .ql-picker-options .ql-picker-item {
  cursor: pointer;
  display: block;
  padding-bottom: 5px;
  padding-top: 5px; }

.ql-toolbar.ql-snow .ql-picker.ql-expanded .ql-picker-label {
  border-color: #ccc;
  color: #ccc;
  z-index: 2; }

.ql-toolbar.ql-snow .ql-picker.ql-expanded .ql-picker-label .ql-fill {
  fill: #ccc; }

.ql-toolbar.ql-snow .ql-picker.ql-expanded .ql-picker-label .ql-stroke {
  stroke: #ccc; }

.ql-toolbar.ql-snow .ql-picker.ql-expanded .ql-picker-options {
  border-color: #ccc;
  box-shadow: rgba(0, 0, 0, 0.2) 0 2px 8px;
  display: block;
  margin-top: -1px;
  z-index: 1; }

.ql-toolbar.ql-snow .ql-color-picker,
.ql-toolbar.ql-snow .ql-icon-picker {
  width: 28px; }

.ql-toolbar.ql-snow .ql-color-picker .ql-picker-label,
.ql-toolbar.ql-snow .ql-icon-picker .ql-picker-label {
  padding: 2px 4px; }

.ql-toolbar.ql-snow .ql-color-picker .ql-picker-label svg,
.ql-toolbar.ql-snow .ql-icon-picker .ql-picker-label svg {
  margin-top: 0px; }

.ql-toolbar.ql-snow .ql-icon-picker .ql-picker-options {
  padding: 4px 0px; }

.ql-toolbar.ql-snow .ql-icon-picker .ql-picker-item {
  height: 24px;
  padding: 2px 4px; }

.ql-toolbar.ql-snow .ql-color-picker.ql-expanded .ql-picker-options,
.ql-toolbar.ql-snow .ql-icon-picker.ql-expanded .ql-picker-options {
  margin-top: -6px; }

.ql-toolbar.ql-snow .ql-color-picker .ql-picker-options {
  padding: 5px;
  width: 152px; }

.ql-toolbar.ql-snow .ql-color-picker .ql-picker-item {
  border: 1px solid transparent;
  float: left;
  height: 16px;
  margin: 2px;
  padding: 0px;
  width: 16px; }

.ql-toolbar.ql-snow .ql-color-picker .ql-picker-item.ql-primary-color {
  margin-bottom: toolbarPadding; }

.ql-toolbar.ql-snow .ql-color-picker .ql-picker-item.ql-selected,
.ql-toolbar.ql-snow .ql-color-picker .ql-picker-item:hover {
  border-color: #000; }

.ql-toolbar.ql-snow .ql-picker.ql-header .ql-picker-label[data-label]:not([data-label=''])::before,
.ql-toolbar.ql-snow .ql-picker.ql-font .ql-picker-label[data-label]:not([data-label=''])::before,
.ql-toolbar.ql-snow .ql-picker.ql-size .ql-picker-label[data-label]:not([data-label=''])::before,
.ql-toolbar.ql-snow .ql-picker.ql-header .ql-picker-item[data-label]:not([data-label=''])::before,
.ql-toolbar.ql-snow .ql-picker.ql-font .ql-picker-item[data-label]:not([data-label=''])::before,
.ql-toolbar.ql-snow .ql-picker.ql-size .ql-picker-item[data-label]:not([data-label=''])::before {
  content: attr(data-label); }

.ql-toolbar.ql-snow .ql-picker.ql-header {
  width: 98px; }

.ql-toolbar.ql-snow .ql-picker.ql-header .ql-picker-label::before,
.ql-toolbar.ql-snow .ql-picker.ql-header .ql-picker-item::before {
  content: 'Normal'; }

.ql-toolbar.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="1"]::before,
.ql-toolbar.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="1"]::before {
  content: 'Heading 1'; }

.ql-toolbar.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="2"]::before,
.ql-toolbar.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="2"]::before {
  content: 'Heading 2'; }

.ql-toolbar.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="3"]::before,
.ql-toolbar.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="3"]::before {
  content: 'Heading 3'; }

.ql-toolbar.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="4"]::before,
.ql-toolbar.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="4"]::before {
  content: 'Heading 4'; }

.ql-toolbar.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="5"]::before,
.ql-toolbar.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="5"]::before {
  content: 'Heading 5'; }

.ql-toolbar.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="6"]::before,
.ql-toolbar.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="6"]::before {
  content: 'Heading 6'; }

.ql-toolbar.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="1"]::before {
  font-size: 2em; }

.ql-toolbar.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="2"]::before {
  font-size: 1.5em; }

.ql-toolbar.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="3"]::before {
  font-size: 1.17em; }

.ql-toolbar.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="4"]::before {
  font-size: 1em; }

.ql-toolbar.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="5"]::before {
  font-size: 0.83em; }

.ql-toolbar.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="6"]::before {
  font-size: 0.67em; }

.ql-toolbar.ql-snow .ql-picker.ql-font {
  width: 108px; }

.ql-toolbar.ql-snow .ql-picker.ql-font .ql-picker-label::before,
.ql-toolbar.ql-snow .ql-picker.ql-font .ql-picker-item::before {
  content: 'Sans Serif'; }

.ql-toolbar.ql-snow .ql-picker.ql-font .ql-picker-label[data-value=serif]::before,
.ql-toolbar.ql-snow .ql-picker.ql-font .ql-picker-item[data-value=serif]::before {
  content: 'Serif'; }

.ql-toolbar.ql-snow .ql-picker.ql-font .ql-picker-label[data-value=monospace]::before,
.ql-toolbar.ql-snow .ql-picker.ql-font .ql-picker-item[data-value=monospace]::before {
  content: 'Monospace'; }

.ql-toolbar.ql-snow .ql-picker.ql-font .ql-picker-item[data-value=serif]::before {
  font-family: Georgia, Times New Roman, serif; }

.ql-toolbar.ql-snow .ql-picker.ql-font .ql-picker-item[data-value=monospace]::before {
  font-family: Monaco, Courier New, monospace; }

.ql-toolbar.ql-snow .ql-picker.ql-size {
  width: 98px; }

.ql-toolbar.ql-snow .ql-picker.ql-size .ql-picker-label::before,
.ql-toolbar.ql-snow .ql-picker.ql-size .ql-picker-item::before {
  content: 'Normal'; }

.ql-toolbar.ql-snow .ql-picker.ql-size .ql-picker-label[data-value=small]::before,
.ql-toolbar.ql-snow .ql-picker.ql-size .ql-picker-item[data-value=small]::before {
  content: 'Small'; }

.ql-toolbar.ql-snow .ql-picker.ql-size .ql-picker-label[data-value=large]::before,
.ql-toolbar.ql-snow .ql-picker.ql-size .ql-picker-item[data-value=large]::before {
  content: 'Large'; }

.ql-toolbar.ql-snow .ql-picker.ql-size .ql-picker-label[data-value=huge]::before,
.ql-toolbar.ql-snow .ql-picker.ql-size .ql-picker-item[data-value=huge]::before {
  content: 'Huge'; }

.ql-toolbar.ql-snow .ql-picker.ql-size .ql-picker-item[data-value=small]::before {
  font-size: 10px; }

.ql-toolbar.ql-snow .ql-picker.ql-size .ql-picker-item[data-value=large]::before {
  font-size: 18px; }

.ql-toolbar.ql-snow .ql-picker.ql-size .ql-picker-item[data-value=huge]::before {
  font-size: 32px; }

.ql-toolbar.ql-snow .ql-color-picker.ql-background .ql-picker-item {
  background-color: #fff; }

.ql-toolbar.ql-snow .ql-color-picker.ql-color .ql-picker-item {
  background-color: #000; }

.ql-toolbar.ql-snow + .ql-container.ql-snow {
  border-top: 0px; }

.ql-snow .ql-tooltip {
  background-color: #fff;
  border: 1px solid #ccc;
  box-shadow: 0px 0px 5px #ddd;
  color: #444; }

.ql-snow .ql-tooltip input[type=text] {
  border: 1px solid #ccc;
  font-size: 13px;
  margin: 0px;
  padding: 3px 5px; }

.ql-container.ql-snow {
  border: 1px solid #ccc; }

.ql-container.ql-snow a {
  color: #06c; }

.ql-container.ql-snow * {
  box-sizing: border-box; }
`, "",{"version":3,"sources":["webpack://./src/layout/layout.css"],"names":[],"mappings":"AAAA,gBAAgB;AAChB,YAAY;AACZ,SAAS;AACT,aAAa;AACb,cAAc;AACd,WAAW;AACX,WAAW;AACX;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,iBAAiB;EAEjB,WAAW;EAEX,oBAAoB;EAEpB,yBAAyB;EAEzB,iBAAiB;EAEjB,UAAU;EACV,+DAA+D;EAC/D,QAAQ;EACR,4GAA4G;EAC5G,UAAU,EAAE;EACZ;IACE,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;IAClB,SAAS;IACT,QAAQ;IACR,kBAAkB;IAClB,iBAAiB,EAAE;EACrB;IACE,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,yBAAyB;IACzB,YAAY;IACZ,kBAAkB;IAClB,MAAM;IACN,OAAO;IAEP,kDAAkD,EAAE;EACtD;IAEE,sBAAsB,EAAE;;AAQ5B;EACE;IACE,mBAAmB;IACnB,2BAA2B,EAAE;EAC/B;IACE,mBAAmB;IACnB,2BAA2B,EAAE,EAAE;;AAEnC;EACE,sBAAsB,EAAE;;AAE1B;EACE,YAAY,EAAE;;AAEhB;EACE,sDAAsD;EACtD,eAAe;EACf,cAAc;EACd,yBAAyB;EACzB,SAAS;EACT,UAAU;EACV,gBAAgB,EAAE;;AAEpB;EACE,qBAAqB,EAAE;;AAEzB;EACE,UAAU,EAAE;EACZ;IACE,eAAe;IACf,YAAY;IACZ,6BAA6B;IAC7B,0CAA0C;IAC1C,cAAc;IACd,YAAY;IACZ,QAAQ;IACR,mBAAmB;IACnB,iBAAiB;IAEjB,WAAW;IAEX,oBAAoB;IAEpB,yBAAyB;IAEzB,iBAAiB;IAEjB,UAAU;IACV,+DAA+D;IAC/D,QAAQ;IACR,4GAA4G;IAC5G,UAAU;IAIV,qBAAqB,EAAE;IACvB;MACE,YAAY;MACZ,cAAc;MAGd,uBAAuB,EAAE;MACzB;QACE,kBAAkB;QAClB,cAAc;QACd,iBAAiB;QACjB,qBAAqB;QACrB,qBAAqB;QAIrB,sBAAsB,EAAE;QACxB;UACE,cAAc,EAAE;QAClB;UACE,cAAc,EAAE;QAClB;UACE,eAAe;UACf,aAAa,EAAE;QACjB;UACE,kBAAkB;UAClB,eAAe;UACf,WAAW;UACX,SAAS;UACT,WAAW;UACX,YAAY;UACZ,kBAAkB;UAClB,iBAAiB;UACjB,cAAc;UACd,yBAAyB;UAGzB,kBAAkB,EAAE;IAC1B;MACE,UAAU;MACV,kBAAkB;MAClB,qBAAqB;MACrB,SAAS;MACT,iBAAiB,EAAE;MACnB;QACE,qBAAqB;QACrB,cAAc;QACd,eAAe;QACf,uBAAuB;QACvB,gCAAgC;QAChC,eAAe;QAEf,gBAAgB;QAChB,cAAc;QACd,YAAY;QACZ,0BAA0B;QAC1B,WAAW;QAGX,kBAAkB,EAAE;QACpB;UACE,cAAc;UACd,WAAW;UAIX,gCAAwB;UAAxB,wBAAwB,EAAE;QAC5B;UACE,cAAc;UACd,WAAW;UAIX,6BAAwB;UAAxB,wBAAwB,EAAE;QAC5B;UACE,cAAc;UACd,WAAW;UAIX,6BAAwB;UAAxB,wBAAwB,EAAE;QAC5B;UACE,cAAc;UACd,WAAW;UAIX,4BAAwB;UAAxB,wBAAwB,EAAE;MAC9B;QACE,eAAe;QACf,kBAAkB;QAClB,SAAS;QACT,SAAS;QACT,cAAc,EAAE;MAClB;QACE,4BAA4B,EAAE;QAC9B;UACE,UAAU,EAAE;QACd;UACE,UAAU,EAAE;QACd;UACE,UAAU,EAAE;QACd;UACE,UAAU,EAAE;MAChB;QACE,cAAc,EAAE;IACpB;MACE,eAAe;MACf,qBAAqB;MACrB,qBAAqB;MACrB,cAAc;MAId,sBAAsB,EAAE;MACxB;QACE,cAAc,EAAE;MAClB;QACE,cAAc,EAAE;IACpB;MACE,eAAe,EAAE;EACrB;IACE,uBAAuB;IACvB,gBAAgB;IAChB,YAAY,EAAE;IACd;MACE,gBAAgB,EAAE;IACpB;MACE,mBAAmB;MACnB,YAAY;MACZ,yBAAyB,EAAE;IAC7B;MACE,cAAc;MACd,kBAAkB,EAAE;IACtB;MACE,wBAAwB;MACxB,qBAAqB,EAAE;EAC3B;IACE,eAAe;IACf,YAAY;IACZ,YAAY;IACZ,YAAY;IACZ,iBAAiB;IACjB,sBAAsB;IACtB,yBAAyB;IAIzB,qBAAqB;IACrB,mBAAmB;IACnB,iBAAiB;IAEjB,WAAW;IAEX,oBAAoB;IAEpB,yBAAyB;IAEzB,iBAAiB;IAEjB,UAAU;IACV,gEAAgE;IAChE,QAAQ;IACR,mHAAmH;IACnH,UAAU;IAGV,yCAAyC,EAAE;IAC3C;MACE,cAAc;MACd,eAAe,EAAE;IACnB;MACE,kBAAkB;MAClB,gBAAgB,EAAE;IACpB;MACE,kBAAkB;MAClB,eAAe,EAAE;MACjB;QACE,WAAW;QACX,YAAY,EAAE;MAChB;QACE,eAAe;QACf,cAAc;QACd,qBAAqB;QACrB,mBAAmB;QAInB,sBAAsB,EAAE;QACxB;UACE,qBAAqB;UACrB,eAAe;UACf,sBAAsB,EAAE;QAC1B;UACE,cAAc,EAAE;MACpB;QACE,gBAAgB;QAChB,yBAAyB;QACzB,gBAAgB;QAChB,aAAa;QAIb,yBAAyB;QAIzB,0DAA0D,EAAE;QAC5D;UACE,iBAAiB,EAAE;QACrB;UACE,WAAW;UACX,yBAAyB;UACzB,cAAc;UACd,gBAAgB,EAAE;UAClB;YACE,cAAc,EAAE;UAClB;YACE,kBAAkB;YAClB,sBAAsB,EAAE;UAC1B;YACE,sBAAsB,EAAE;QAC5B;UACE,cAAc,EAAE;IACtB;MACE,qBAAqB;MACrB,SAAS;MACT,UAAU,EAAE;MACZ;QACE,eAAe;QACf,kBAAkB;QAClB,cAAc;QACd,qBAAqB;QACrB,eAAe;QACf,yBAAyB;QACzB,cAAc;QACd,8CAA8C,EAAE;QAChD;UACE,eAAe;UACf,sBAAsB,EAAE;QAC1B;UACE,kBAAkB;UAClB,sBAAsB,EAAE;QAC1B;UACE,YAAY,EAAE;QAChB;UACE,cAAc,EAAE;QAClB;UACE,yBAAyB;UACzB,cAAc,EAAE;UAChB;YACE,YAAY,EAAE;MACpB;QACE,yBAAyB;QACzB,cAAc,EAAE;QAChB;UACE,YAAY,EAAE;MAClB;QACE,iBAAiB,EAAE;MACrB;QACE,yBAAyB;QACzB,gBAAgB;QAChB,mBAAmB;QACnB,aAAa;QAKb,+BAA+B;QAI/B,yBAAyB;QAIzB,0DAA0D,EAAE;QAC5D;UACE,eAAe;UACf,+BAA+B;UAC/B,eAAe;UACf,kBAAkB,EAAE;QACtB;UACE,qBAAqB,EAAE;MAC3B;QACE,YAAY;QACZ,eAAe,EAAE;MACnB;QACE,eAAe;QACf,eAAe;QACf,YAAY;QACZ,WAAW;QACX,YAAY;QACZ,iBAAiB;QACjB,kBAAkB;QAClB,cAAc;QACd,yBAAyB;QAGzB,kBAAkB,EAAE;IACxB;MACE,mBAAmB;MACnB,iBAAiB;MAEjB,WAAW;MAEX,oBAAoB;MAEpB,yBAAyB;MAEzB,iBAAiB;MAEjB,UAAU;MACV,gEAAgE;MAChE,QAAQ;MACR,mHAAmH;MACnH,UAAU,EAAE;MACZ;QACE,cAAc,EAAE;QAChB;UACE,cAAc,EAAE;MACpB;QACE,yBAAyB,EAAE;QAC3B;UACE,cAAc;UACd,cAAc;UACd,2CAA2C,EAAE;UAC7C;YACE,cAAc,EAAE;MACtB;QACE,cAAc;QACd,2CAA2C,EAAE;QAC7C;UACE,cAAc,EAAE;QAClB;UACE,yBAAyB;UACzB,cAAc,EAAE;MACpB;QACE,yBAAyB;QACzB,cAAc,EAAE;MAClB;QACE,yBAAyB,EAAE;QAC3B;UACE,YAAY,EAAE;QAChB;UACE,yBAAyB;UACzB,cAAc,EAAE;EACxB;IAIE,4BAA4B;IAC5B,4BAA4B,EAAE;EAChC;IAIE,4BAA4B;IAC5B,yBAAyB;IACzB,gBAAgB,EAAE;IAClB;MACE,sBAAsB,EAAE;IAC1B;MACE,sBAAsB,EAAE;;AAE9B,eAAe;AACf;EACE;IACE,YAAY,EAAE;EAChB;IACE,OAAO,EAAE;EACX;IACE,cAAc,EAAE;EAClB;IACE,OAAO,EAAE;EACX;IACE,WAAW,EAAE;EACf;IACE,OAAO,EAAE;EACX;IACE,WAAW,EAAE;EACf;IACE,kBAAkB,EAAE;EACtB;IACE,YAAY,EAAE;EAChB;IACE,OAAO,EAAE;EACX;IACE,cAAc,EAAE,EAAE;;AAEtB;EACE;IACE,OAAO,EAAE;EACX;IACE,cAAc,EAAE;EAClB;IACE,YAAY;IACZ,gBAAgB,EAAE;EACpB;IACE,aAAa;IACb,eAAe;IACf,WAAW;IACX,YAAY;IACZ,SAAS;IACT,OAAO;IACP,YAAY;IACZ,yBAAyB;IACzB,YAAY;IACZ,yBAAyB,EAAE;EAC7B;IACE,QAAQ,EAAE;EACZ;IACE,cAAc,EAAE;EAClB;IACE,gBAAgB,EAAE,EAAE;;AAExB,eAAe;AACf;EACE,mBAAmB;EACnB,SAAS;EACT,eAAe,EAAE;;AAEnB;EACE,eAAe;EACf,mBAAmB;EACnB,SAAS,EAAE;;AAEb;EACE,yBAAyB;EACzB,YAAY;EACZ,mBAAmB;EAGnB,kBAAkB,EAAE;EACpB;IACE,mBAAmB,EAAE;EACvB;IACE,qBAAqB;IACrB,gCAAgC;IAChC,aAAa;IACb,eAAe,EAAE;IACjB;MACE,kBAAkB,EAAE;;AAE1B;EACE,mBAAmB,EAAE;;AAEvB,cAAc;AACd;EACE,kBAAkB;EAClB,mBAAmB,EAAE;EACrB;IACE,eAAe;IACf,gBAAgB;IAChB,kBAAkB,EAAE;EACtB;IACE,cAAc;IACd,cAAc;IACd,eAAe,EAAE;EACnB;IACE,SAAS;IACT,WAAW;IACX,eAAe;IACf,kBAAkB,EAAE;IACpB;MACE,cAAc;MACd,iBAAiB;MAGjB,kBAAkB,EAAE;IACtB;MACE,yBAAyB,EAAE;IAC7B;MACE,yBAAyB,EAAE;IAC7B;MACE,yBAAyB,EAAE;;AAEjC;EACE,aAAa,EAAE;EACf;IACE,WAAW;IACX,cAAc;IACd,WAAW,EAAE;EACf;IACE,YAAY;IACZ,WAAW;IACX,UAAU;IACV,kBAAkB;IAClB,YAAY,EAAE;IACd;MACE,eAAe,EAAE;EACrB;IACE,YAAY;IACZ,yBAAyB;IACzB,WAAW;IACX,UAAU;IACV,YAAY,EAAE;IACd;MACE,eAAe;MACf,sBAAsB;MACtB,mBAAmB,EAAE;IACvB;MACE,cAAc;MACd,eAAe;MACf,cAAc,EAAE;;AAEtB;EACE,qBAAqB;EACrB,SAAS;EACT,UAAU,EAAE;EACZ;IACE,mBAAmB;IACnB,gCAAgC,EAAE;IAClC;MACE,WAAW;MACX,cAAc;MACd,WAAW,EAAE;EACjB;IACE,sBAAsB;IACtB,kBAAkB,EAAE;EACtB;IACE,sBAAsB,EAAE;EAC1B;IACE,YAAY,EAAE;IACd;MACE,eAAe,EAAE;EACrB;IACE,iBAAiB,EAAE;;AAEvB;EACE,iBAAiB,EAAE;;AAErB;EACE,qBAAqB;EACrB,UAAU;EACV,SAAS,EAAE;EACX;IACE,gCAAgC,EAAE;IAClC;MACE,YAAY;MACZ,WAAW;MACX,sBAAsB;MACtB,qBAAqB;MACrB,kBAAkB;MAClB,cAAc;MAGd,kBAAkB;MAIlB,iCAAiC,EAAE;MACnC;QACE,kBAAkB;QAClB,WAAW;QACX,SAAS;QACT,eAAe,EAAE;MACnB;QACE,kBAAkB;QAClB,WAAW;QACX,SAAS;QACT,eAAe;QACf,cAAc,EAAE;MAClB;QACE,eAAe;QACf,yBAAyB,EAAE;IAC/B;MACE,SAAS,EAAE;;AAEjB;EACE,iBAAiB,EAAE;;AAErB;EACE,qBAAqB;EACrB,UAAU;EACV,SAAS,EAAE;EACX;IACE,gCAAgC;IAChC,iBAAiB,EAAE;IACnB;MACE,eAAe;MACf,cAAc;MACd,yBAAyB;MACzB,gBAAgB;MAChB,qBAAqB;MACrB,mBAAmB;MAGnB,kBAAkB,EAAE;IACtB;MACE,6BAA6B,EAAE;IACjC;MACE,SAAS,EAAE;IACb;MACE,eAAe;MACf,eAAe,EAAE;IACnB;MACE,iBAAiB;MACjB,cAAc,EAAE;;AAEtB;;;;;EAKE;AACF;EACE,sBAAsB;EACtB,yCAAyC;EACzC,eAAe;EACf,YAAY;EACZ,WAAW;EACX,kBAAkB,EAAE;;AAEtB;EACE,eAAe;EACf,kBAAkB;EAClB,QAAQ,EAAE;;AAEZ;EACE,SAAS;EACT,UAAU,EAAE;;AAEd;EACE,sBAAsB;EACtB,YAAY;EACZ,iBAAiB;EACjB,YAAY;EACZ,aAAa;EACb,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,qBAAqB,EAAE;;AAEzB;;;;;;;;;;;EAWE,SAAS;EACT,UAAU;EACV,sEAAsE,EAAE;;AAE1E;EACE,kBAAkB,EAAE;;AAEtB;EACE,iBAAiB;EACjB,uBAAuB,EAAE;;AAE3B;EACE,qBAAqB,EAAE;;AAEzB;EACE,qBAAqB;EACrB,kBAAkB,EAAE;;AAEtB;EACE,sEAAsE;EACtE,2BAA2B,EAAE;;AAE/B;EACE,wCAAwC;EACxC,mBAAmB;EACnB,kBAAkB;EAClB,WAAW;EACX,iBAAiB,EAAE;;AAErB;EACE,yBAAyB,EAAE;;AAE7B;EACE,0CAA0C;EAC1C,mBAAmB,EAAE;;AAEvB;EACE,+DAA+D,EAAE;;AAEnE;EACE,yBAAyB,EAAE;;AAE7B;EACE,0CAA0C;EAC1C,mBAAmB,EAAE;;AAEvB;EACE,wDAAwD,EAAE;;AAE5D;EACE,yBAAyB,EAAE;;AAE7B;EACE,sCAAsC;EACtC,oBAAoB,EAAE;;AAExB;EACE,iDAAiD,EAAE;;AAErD;EACE,yBAAyB,EAAE;;AAE7B;EACE,0CAA0C;EAC1C,oBAAoB,EAAE;;AAExB;EACE,0CAA0C,EAAE;;AAE9C;EACE,yBAAyB,EAAE;;AAE7B;EACE,0CAA0C;EAC1C,oBAAoB,EAAE;;AAExB;EACE,mCAAmC,EAAE;;AAEvC;EACE,yBAAyB,EAAE;;AAE7B;EACE,sCAAsC;EACtC,oBAAoB,EAAE;;AAExB;EACE,4BAA4B,EAAE;;AAEhC;EACE,yBAAyB,EAAE;;AAE7B;EACE,0CAA0C;EAC1C,oBAAoB,EAAE;;AAExB;EACE,qBAAqB,EAAE;;AAEzB;EACE,yBAAyB,EAAE;;AAE7B;EACE,0CAA0C;EAC1C,oBAAoB,EAAE;;AAExB;EACE,kBAAkB,EAAE;;AAEtB;EACE,kBAAkB,EAAE;;AAEtB;EACE,mBAAmB,EAAE;;AAEvB;EACE,mBAAmB,EAAE;;AAEvB;EACE,mBAAmB,EAAE;;AAEvB;EACE,mBAAmB,EAAE;;AAEvB;EACE,mBAAmB,EAAE;;AAEvB;EACE,mBAAmB,EAAE;;AAEvB;EACE,cAAc,EAAE;;AAElB;EACE,cAAc,EAAE;;AAElB;EACE,kBAAkB,EAAE;;AAEtB;EACE,sBAAsB,EAAE;;AAE1B;EACE,yBAAyB,EAAE;;AAE7B;EACE,sBAAsB,EAAE;;AAE1B;EACE,sBAAsB,EAAE;;AAE1B;EACE,yBAAyB,EAAE;;AAE7B;EACE,sBAAsB,EAAE;;AAE1B;EACE,sBAAsB,EAAE;;AAE1B;EACE,WAAW,EAAE;;AAEf;EACE,cAAc,EAAE;;AAElB;EACE,WAAW,EAAE;;AAEf;EACE,WAAW,EAAE;;AAEf;EACE,cAAc,EAAE;;AAElB;EACE,WAAW,EAAE;;AAEf;EACE,WAAW,EAAE;;AAEf;EACE,4CAA4C,EAAE;;AAEhD;EACE,2CAA2C,EAAE;;AAE/C;EACE,eAAe,EAAE;;AAEnB;EACE,eAAe,EAAE;;AAEnB;EACE,eAAe,EAAE;;AAEnB;EACE,cAAc;EACd,mBAAmB,EAAE;;AAEvB;EACE,kBAAkB,EAAE;;AAEtB;EACE,mBAAmB,EAAE;;AAEvB;EACE,iBAAiB,EAAE;;AAErB;EACE,yBAAyB;EACzB,+BAA+B;EAC/B,kBAAkB;EAClB,oBAAoB;EACpB,kBAAkB,EAAE;;AAEtB;EACE,aAAa,EAAE;;AAEjB;EACE,kBAAkB,EAAE;;AAEtB;EACE,eAAe;EACf,qBAAqB,EAAE;;AAEzB;;EAEE,YAAY;EACZ,cAAc,EAAE;;AAElB;EACE,WAAW,EAAE;;AAEf;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,gBAAgB;EAChB,WAAW,EAAE;;AAEf;EACE,YAAY,EAAE;;AAEhB;EACE,UAAU;EACV,qBAAqB;EACrB,sBAAsB;EACtB,eAAe,EAAE;;AAEnB;EACE,UAAU;EACV,sBAAsB;EACtB,eAAe,EAAE;;AAEnB;EACE,UAAU,EAAE;;AAEd;EACE,kBAAkB,EAAE;;AAEtB;;EAEE,eAAe,EAAE;;AAEnB;EACE,YAAY,EAAE;;AAEhB;EACE,cAAc,EAAE;;AAElB;EACE,gBAAgB,EAAE;;AAEpB;EACE,iBAAiB,EAAE;;AAErB;EACE,cAAc,EAAE;;AAElB;EACE,iBAAiB,EAAE;;AAErB;EACE,iBAAiB,EAAE;;AAErB;EACE,qBAAqB,EAAE;;AAEzB;EACE,0BAA0B,EAAE;;AAE9B;EACE,2BAA2B;EAC3B,kBAAkB;EAClB,eAAe;EACf,kBAAkB,EAAE;;AAEtB;EACE,iBAAiB,EAAE;;AAErB;;EAEE,yBAAyB,EAAE;;AAE7B;;EAEE,kBAAkB,EAAE;;AAEtB;EACE,cAAc;EACd,mBAAmB;EACnB,gBAAgB,EAAE;;AAEpB;;EAEE,cAAc;EACd,oBAAoB,EAAE;;AAExB;;EAEE,eAAe;EACf,gBAAgB,EAAE;;AAEpB;EACE,kBAAkB;EAClB,qBAAqB,EAAE;;AAEzB;EACE,iBAAiB,EAAE;;AAErB;EACE,eAAe,EAAE;;AAEnB;EACE,aAAa;EACb,kBAAkB;EAClB,YAAY,EAAE;;AAEhB;EACE,YAAY;EACZ,WAAW,EAAE;;AAEf;;EAEE,sBAAsB;EACtB,qBAAqB;EACrB,WAAW;EACX,iBAAiB;EACjB,YAAY;EACZ,UAAU,EAAE;;AAEd;EACE,WAAW;EACX,iBAAiB,EAAE;;AAErB;EACE,sBAAsB,EAAE;;AAE1B;EACE,WAAW;EACX,iBAAiB,EAAE;;AAErB;EACE,aAAa;EACb,gBAAgB;EAChB,kBAAkB,EAAE;;AAEtB;EACE,SAAS;EACT,OAAO;EACP,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,QAAQ;EACR,MAAM,EAAE;;AAEV;EACE,uBAAuB;EACvB,WAAW;EACX,kBAAkB;EAClB,cAAc;EACd,kBAAkB,EAAE;;AAEtB;EACE,qBAAqB;EACrB,iBAAiB;EACjB,iBAAiB,EAAE;;AAErB;EACE,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB,EAAE;;AAEvB;EACE,aAAa;EACb,YAAY;EACZ,YAAY,EAAE;;AAEhB;EACE,qBAAqB;EACrB,gBAAgB;EAChB,kBAAkB;EAClB,uBAAuB;EACvB,mBAAmB,EAAE;;AAEvB;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,gBAAgB,EAAE;;AAEpB;EACE,4BAA4B;EAC5B,eAAe;EACf,gBAAgB;EAChB,kBAAkB,EAAE;;AAEtB;EACE,iBAAiB;EACjB,gBAAgB,EAAE;;AAEpB;EACE,iBAAiB,EAAE;;AAErB;;EAEE,aAAa,EAAE;;AAEjB;EACE,qBAAqB,EAAE;;AAEzB;EACE,iBAAiB;EACjB,eAAe;EACf,kBAAkB,EAAE;;AAEtB;EACE,sBAAsB;EACtB,sBAAsB;EACtB,+DAA+D;EAC/D,YAAY,EAAE;;AAEhB;EACE,sBAAsB,EAAE;;AAE1B;EACE,qBAAqB;EACrB,kBAAkB;EAClB,sBAAsB,EAAE;;AAE1B;;;;;;EAME,WAAW,EAAE;;AAEf;;;;;;;;;;;;EAYE,UAAU,EAAE;;AAEd;;;;;;;;;;;;EAYE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;;EAEE,UAAU,EAAE;;AAEd;EACE,aAAa,EAAE;;AAEjB;EACE,eAAe,EAAE;;AAEnB;EACE,aAAa,EAAE;;AAEjB;EACE,WAAW;EACX,qBAAqB;EACrB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,sBAAsB,EAAE;;AAE1B;EACE,6BAA6B;EAC7B,eAAe;EACf,qBAAqB;EACrB,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,WAAW,EAAE;;AAEf;EACE,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,WAAW,EAAE;;AAEf;EACE,sBAAsB,EAAE;;AAE1B;EACE,sBAAsB;EACtB,6BAA6B;EAC7B,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB,EAAE;;AAEvB;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,gBAAgB,EAAE;;AAEpB;EACE,kBAAkB;EAClB,WAAW;EACX,UAAU,EAAE;;AAEd;EACE,UAAU,EAAE;;AAEd;EACE,YAAY,EAAE;;AAEhB;EACE,kBAAkB;EAClB,wCAAwC;EACxC,cAAc;EACd,gBAAgB;EAChB,UAAU,EAAE;;AAEd;;EAEE,WAAW,EAAE;;AAEf;;EAEE,gBAAgB,EAAE;;AAEpB;;EAEE,eAAe,EAAE;;AAEnB;EACE,gBAAgB,EAAE;;AAEpB;EACE,YAAY;EACZ,gBAAgB,EAAE;;AAEpB;;EAEE,gBAAgB,EAAE;;AAEpB;EACE,YAAY;EACZ,YAAY,EAAE;;AAEhB;EACE,6BAA6B;EAC7B,WAAW;EACX,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,WAAW,EAAE;;AAEf;EACE,6BAA6B,EAAE;;AAEjC;;EAEE,kBAAkB,EAAE;;AAEtB;;;;;;EAME,yBAAyB,EAAE;;AAE7B;EACE,WAAW,EAAE;;AAEf;;EAEE,iBAAiB,EAAE;;AAErB;;EAEE,oBAAoB,EAAE;;AAExB;;EAEE,oBAAoB,EAAE;;AAExB;;EAEE,oBAAoB,EAAE;;AAExB;;EAEE,oBAAoB,EAAE;;AAExB;;EAEE,oBAAoB,EAAE;;AAExB;;EAEE,oBAAoB,EAAE;;AAExB;EACE,cAAc,EAAE;;AAElB;EACE,gBAAgB,EAAE;;AAEpB;EACE,iBAAiB,EAAE;;AAErB;EACE,cAAc,EAAE;;AAElB;EACE,iBAAiB,EAAE;;AAErB;EACE,iBAAiB,EAAE;;AAErB;EACE,YAAY,EAAE;;AAEhB;;EAEE,qBAAqB,EAAE;;AAEzB;;EAEE,gBAAgB,EAAE;;AAEpB;;EAEE,oBAAoB,EAAE;;AAExB;EACE,4CAA4C,EAAE;;AAEhD;EACE,2CAA2C,EAAE;;AAE/C;EACE,WAAW,EAAE;;AAEf;;EAEE,iBAAiB,EAAE;;AAErB;;EAEE,gBAAgB,EAAE;;AAEpB;;EAEE,gBAAgB,EAAE;;AAEpB;;EAEE,eAAe,EAAE;;AAEnB;EACE,eAAe,EAAE;;AAEnB;EACE,eAAe,EAAE;;AAEnB;EACE,eAAe,EAAE;;AAEnB;EACE,sBAAsB,EAAE;;AAE1B;EACE,sBAAsB,EAAE;;AAE1B;EACE,eAAe,EAAE;;AAEnB;EACE,sBAAsB;EACtB,sBAAsB;EACtB,4BAA4B;EAC5B,WAAW,EAAE;;AAEf;EACE,sBAAsB;EACtB,eAAe;EACf,WAAW;EACX,gBAAgB,EAAE;;AAEpB;EACE,sBAAsB,EAAE;;AAE1B;EACE,WAAW,EAAE;;AAEf;EACE,sBAAsB,EAAE","sourcesContent":["@charset \"UTF-8\";\n/* General */\n/* Menu */\n/* Menu Dark*/\n/* Menu Light*/\n/* Topbar */\n/* Footer */\n.splash-screen {\n  width: 100%;\n  height: 100%;\n  position: fixed;\n  background: #FFFFFF;\n  /* Old browsers */\n  background: -moz-linear-gradient(left, #FFFFFF 0%, #FFFFFF 100%);\n  /* FF3.6+ */\n  background: -webkit-gradient(linear, left top, right top, color-stop(0%, #FFFFFF), color-stop(100%, #FFFFFF));\n  /* Chrome,Safari4+ */\n  background: -webkit-linear-gradient(left, #FFFFFF 0%, #FFFFFF 100%);\n  /* Chrome10+,Safari5.1+ */\n  background: -o-linear-gradient(left, #FFFFFF 0%, #FFFFFF 100%);\n  /* Opera 11.10+ */\n  background: -ms-linear-gradient(left, #FFFFFF 0%, #FFFFFF 100%);\n  /* IE10+ */\n  background: linear-gradient(to right, #FFFFFF 0%, #FFFFFF 100%);\n  /* W3C */\n  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr=$left, endColorstr=$right,GradientType=1 );\n  /* IE6-9 */ }\n  .splash-screen .splash-container {\n    width: 40px;\n    height: 40px;\n    margin: 0px auto;\n    position: absolute;\n    left: 50%;\n    top: 50%;\n    margin-left: -20px;\n    margin-top: -20px; }\n  .splash-screen .splash-double-bounce1, .splash-screen .splash-double-bounce2 {\n    width: 100%;\n    height: 100%;\n    border-radius: 50%;\n    background-color: #10497F;\n    opacity: 0.6;\n    position: absolute;\n    top: 0;\n    left: 0;\n    -webkit-animation: splash-bounce 2.0s infinite ease-in-out;\n    animation: splash-bounce 2.0s infinite ease-in-out; }\n  .splash-screen .splash-double-bounce2 {\n    -webkit-animation-delay: -1.0s;\n    animation-delay: -1.0s; }\n\n@-webkit-keyframes splash-bounce {\n  0%, 100% {\n    -webkit-transform: scale(0); }\n  50% {\n    -webkit-transform: scale(1); } }\n\n@keyframes splash-bounce {\n  0%, 100% {\n    transform: scale(0);\n    -webkit-transform: scale(0); }\n  50% {\n    transform: scale(1);\n    -webkit-transform: scale(1); } }\n\n* {\n  box-sizing: border-box; }\n\nhtml {\n  height: 100%; }\n\nbody {\n  font-family: \"Open Sans\", \"Helvetica Neue\", sans-serif;\n  font-size: 14px;\n  color: #333333;\n  background-color: #edf0f5;\n  margin: 0;\n  padding: 0;\n  min-height: 100%; }\n\na {\n  text-decoration: none; }\n\n.layout-wrapper {\n  padding: 0; }\n  .layout-wrapper .layout-topbar {\n    position: fixed;\n    height: 50px;\n    padding: .7em 1.5em 0em 1.5em;\n    box-shadow: 0px 2px 6px rgba(0, 0, 0, 0.2);\n    color: #ffffff;\n    z-index: 999;\n    right: 0;\n    background: #FFFFFF;\n    /* Old browsers */\n    background: -moz-linear-gradient(left, #FFFFFF 0%, #FFFFFF 100%);\n    /* FF3.6+ */\n    background: -webkit-gradient(linear, left top, right top, color-stop(0%, #FFFFFF), color-stop(100%, #FFFFFF));\n    /* Chrome,Safari4+ */\n    background: -webkit-linear-gradient(left, #FFFFFF 0%, #FFFFFF 100%);\n    /* Chrome10+,Safari5.1+ */\n    background: -o-linear-gradient(left, #FFFFFF 0%, #FFFFFF 100%);\n    /* Opera 11.10+ */\n    background: -ms-linear-gradient(left, #FFFFFF 0%, #FFFFFF 100%);\n    /* IE10+ */\n    background: linear-gradient(to right, #FFFFFF 0%, #FFFFFF 100%);\n    /* W3C */\n    filter: progid:DXImageTransform.Microsoft.gradient( startColorstr=$left, endColorstr=$right,GradientType=1 );\n    /* IE6-9 */\n    -moz-transition: left 0.2s;\n    -o-transition: left 0.2s;\n    -webkit-transition: left 0.2s;\n    transition: left 0.2s; }\n    .layout-wrapper .layout-topbar .layout-topbar-icons {\n      float: right;\n      display: block;\n      -moz-animation-duration: .5s;\n      -webkit-animation-duration: .5s;\n      animation-duration: .5s; }\n      .layout-wrapper .layout-topbar .layout-topbar-icons button {\n        position: relative;\n        color: #10497F;\n        margin-left: 20px;\n        display: inline-block;\n        text-decoration: none;\n        -moz-transition: color 0.2s;\n        -o-transition: color 0.2s;\n        -webkit-transition: color 0.2s;\n        transition: color 0.2s; }\n        .layout-wrapper .layout-topbar .layout-topbar-icons button:hover {\n          color: #77c7ff; }\n        .layout-wrapper .layout-topbar .layout-topbar-icons button span.layout-topbar-icon {\n          font-size: 2em; }\n        .layout-wrapper .layout-topbar .layout-topbar-icons button span.layout-topbar-item-text {\n          font-size: 20px;\n          display: none; }\n        .layout-wrapper .layout-topbar .layout-topbar-icons button span.layout-topbar-badge {\n          position: absolute;\n          font-size: 10px;\n          right: -5px;\n          top: -5px;\n          width: 16px;\n          height: 16px;\n          text-align: center;\n          line-height: 16px;\n          color: #FFFFFF;\n          background-color: #6D9BC7;\n          -moz-border-radius: 50%;\n          -webkit-border-radius: 50%;\n          border-radius: 50%; }\n    .layout-wrapper .layout-topbar .layout-topbar-search {\n      padding: 0;\n      position: relative;\n      display: inline-block;\n      top: -4px;\n      margin-left: 30px; }\n      .layout-wrapper .layout-topbar .layout-topbar-search input {\n        display: inline-block;\n        border: 0 none;\n        font-size: 14px;\n        background: transparent;\n        border-bottom: 2px solid #10497F;\n        outline: 0 none;\n        -webkit-box-shadow: none;\n        box-shadow: none;\n        color: #10497F;\n        width: 300px;\n        padding: 1px 20px 1px 35px;\n        margin: 0px;\n        -moz-border-radius: 2px;\n        -webkit-border-radius: 2px;\n        border-radius: 2px; }\n        .layout-wrapper .layout-topbar .layout-topbar-search input::-webkit-input-placeholder {\n          color: #10497F;\n          opacity: .7;\n          -moz-transition: opacity 0.2s;\n          -o-transition: opacity 0.2s;\n          -webkit-transition: opacity 0.2s;\n          transition: opacity 0.2s; }\n        .layout-wrapper .layout-topbar .layout-topbar-search input:-moz-placeholder {\n          color: #10497F;\n          opacity: .7;\n          -moz-transition: opacity 0.2s;\n          -o-transition: opacity 0.2s;\n          -webkit-transition: opacity 0.2s;\n          transition: opacity 0.2s; }\n        .layout-wrapper .layout-topbar .layout-topbar-search input::-moz-placeholder {\n          color: #10497F;\n          opacity: .7;\n          -moz-transition: opacity 0.2s;\n          -o-transition: opacity 0.2s;\n          -webkit-transition: opacity 0.2s;\n          transition: opacity 0.2s; }\n        .layout-wrapper .layout-topbar .layout-topbar-search input:-ms-input-placeholder {\n          color: #10497F;\n          opacity: .7;\n          -moz-transition: opacity 0.2s;\n          -o-transition: opacity 0.2s;\n          -webkit-transition: opacity 0.2s;\n          transition: opacity 0.2s; }\n      .layout-wrapper .layout-topbar .layout-topbar-search .layout-topbar-search-icon {\n        font-size: 18px;\n        position: absolute;\n        top: -1px;\n        left: 0px;\n        color: #10497F; }\n      .layout-wrapper .layout-topbar .layout-topbar-search:hover input {\n        border-bottom-color: #77c7ff; }\n        .layout-wrapper .layout-topbar .layout-topbar-search:hover input::-webkit-input-placeholder {\n          opacity: 1; }\n        .layout-wrapper .layout-topbar .layout-topbar-search:hover input:-moz-placeholder {\n          opacity: 1; }\n        .layout-wrapper .layout-topbar .layout-topbar-search:hover input::-moz-placeholder {\n          opacity: 1; }\n        .layout-wrapper .layout-topbar .layout-topbar-search:hover input:-ms-input-placeholder {\n          opacity: 1; }\n      .layout-wrapper .layout-topbar .layout-topbar-search:hover .layout-topbar-search-icon {\n        color: #77c7ff; }\n    .layout-wrapper .layout-topbar .layout-menu-button {\n      cursor: pointer;\n      display: inline-block;\n      text-decoration: none;\n      color: #10497F;\n      -moz-transition: color 0.2s;\n      -o-transition: color 0.2s;\n      -webkit-transition: color 0.2s;\n      transition: color 0.2s; }\n      .layout-wrapper .layout-topbar .layout-menu-button span {\n        font-size: 2em; }\n      .layout-wrapper .layout-topbar .layout-menu-button:hover {\n        color: #77c7ff; }\n    .layout-wrapper .layout-topbar button {\n      cursor: pointer; }\n  .layout-wrapper .p-scrollpanel {\n    background: transparent;\n    border-radius: 0;\n    border: none; }\n    .layout-wrapper .p-scrollpanel .p-scrollpanel-content {\n      overflow: scroll; }\n    .layout-wrapper .p-scrollpanel .p-scrollpanel-bar {\n      background: #aaaaaa;\n      opacity: 0.3;\n      filter: alpha(opacity=30); }\n    .layout-wrapper .p-scrollpanel .p-scrollpanel-hidden {\n      display: block;\n      visibility: hidden; }\n    .layout-wrapper .p-scrollpanel .layout-sidebar-scroll-content {\n      width: calc(100% + 18px);\n      padding-bottom: 120px; }\n  .layout-wrapper .layout-sidebar {\n    position: fixed;\n    width: 250px;\n    height: 100%;\n    z-index: 999;\n    user-select: none;\n    -moz-user-select: none;\n    -webkit-user-select: none;\n    -moz-transition: left 0.2s;\n    -o-transition: left 0.2s;\n    -webkit-transition: left 0.2s;\n    transition: left 0.2s;\n    background: #f3f4f9;\n    /* Old browsers */\n    background: -moz-linear-gradient(top, #f3f4f9 0%, #d7dbe8 100%);\n    /* FF3.6+ */\n    background: -webkit-gradient(linear, left top, left bottom, color-stop(0%, #f3f4f9), color-stop(100%, #d7dbe8));\n    /* Chrome,Safari4+ */\n    background: -webkit-linear-gradient(top, #f3f4f9 0%, #d7dbe8 100%);\n    /* Chrome10+,Safari5.1+ */\n    background: -o-linear-gradient(top, #f3f4f9 0%, #d7dbe8 100%);\n    /* Opera 11.10+ */\n    background: -ms-linear-gradient(top, #f3f4f9 0%, #d7dbe8 100%);\n    /* IE10+ */\n    background: linear-gradient(to bottom, #f3f4f9 0%, #d7dbe8 100%);\n    /* W3C */\n    filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#ffffff', endColorstr='#000000',GradientType=0 );\n    /* IE6-9 */\n    -webkit-box-shadow: 0 0 6px 0 rgba(0, 0, 0, 0.16);\n    -moz-box-shadow: 0 0 6px 0 rgba(0, 0, 0, 0.16);\n    box-shadow: 0 0 6px 0 rgba(0, 0, 0, 0.16); }\n    .layout-wrapper .layout-sidebar .logo-title {\n      color: #ffffff;\n      font-size: 20px; }\n    .layout-wrapper .layout-sidebar .layout-logo {\n      text-align: center;\n      margin-top: 24px; }\n    .layout-wrapper .layout-sidebar .profile {\n      text-align: center;\n      padding: 20px 0; }\n      .layout-wrapper .layout-sidebar .profile img {\n        width: 56px;\n        margin: 10px; }\n      .layout-wrapper .layout-sidebar .profile .profile-link {\n        cursor: pointer;\n        color: #232428;\n        display: inline-block;\n        margin-bottom: 10px;\n        -moz-transition: color 0.2s;\n        -o-transition: color 0.2s;\n        -webkit-transition: color 0.2s;\n        transition: color 0.2s; }\n        .layout-wrapper .layout-sidebar .profile .profile-link i {\n          display: inline-block;\n          font-size: 16px;\n          vertical-align: middle; }\n        .layout-wrapper .layout-sidebar .profile .profile-link:hover {\n          color: #0388e5; }\n      .layout-wrapper .layout-sidebar .profile > ul {\n        overflow: hidden;\n        background-color: #ffffff;\n        text-align: left;\n        max-height: 0;\n        -moz-transition-duration: 0.2s;\n        -webkit-transition-duration: 0.2s;\n        -o-transition-duration: 0.2s;\n        transition-duration: 0.2s;\n        -webkit-transition-timing-function: cubic-bezier(0.86, 0, 0.07, 1);\n        -moz-transition-timing-function: cubic-bezier(0.86, 0, 0.07, 1);\n        -o-transition-timing-function: cubic-bezier(0.86, 0, 0.07, 1);\n        transition-timing-function: cubic-bezier(0.86, 0, 0.07, 1); }\n        .layout-wrapper .layout-sidebar .profile > ul.profile-expanded {\n          max-height: 500px; }\n        .layout-wrapper .layout-sidebar .profile > ul li button {\n          width: 100%;\n          padding: 1em 15px 1em 1em;\n          border: 0 none;\n          border-radius: 0; }\n          .layout-wrapper .layout-sidebar .profile > ul li button:hover {\n            color: #0388e5; }\n          .layout-wrapper .layout-sidebar .profile > ul li button span {\n            margin-left: .25em;\n            vertical-align: middle; }\n          .layout-wrapper .layout-sidebar .profile > ul li button i {\n            vertical-align: middle; }\n        .layout-wrapper .layout-sidebar .profile > ul li:last-child > button {\n          border: 0 none; }\n    .layout-wrapper .layout-sidebar ul {\n      list-style-type: none;\n      margin: 0;\n      padding: 0; }\n      .layout-wrapper .layout-sidebar ul li a {\n        cursor: pointer;\n        position: relative;\n        color: #232428;\n        text-decoration: none;\n        font-size: 14px;\n        padding: 1em 15px 1em 1em;\n        display: block;\n        border-top: 1px solid rgba(207, 211, 224, 0.6); }\n        .layout-wrapper .layout-sidebar ul li a i {\n          font-size: 18px;\n          vertical-align: middle; }\n        .layout-wrapper .layout-sidebar ul li a span {\n          margin-left: .25em;\n          vertical-align: middle; }\n        .layout-wrapper .layout-sidebar ul li a .menuitem-toggle-icon {\n          float: right; }\n        .layout-wrapper .layout-sidebar ul li a:hover {\n          color: #0388e5; }\n        .layout-wrapper .layout-sidebar ul li a.active-route {\n          background-color: #ffffff;\n          color: #0388e5; }\n          .layout-wrapper .layout-sidebar ul li a.active-route .menuitem-toggle-icon:before {\n            content: \"\"; }\n      .layout-wrapper .layout-sidebar ul li.active-menuitem > a {\n        background-color: #ffffff;\n        color: #0388e5; }\n        .layout-wrapper .layout-sidebar ul li.active-menuitem > a .menuitem-toggle-icon:before {\n          content: \"\"; }\n      .layout-wrapper .layout-sidebar ul li.active-menuitem > ul {\n        max-height: 500px; }\n      .layout-wrapper .layout-sidebar ul li ul {\n        background-color: #ffffff;\n        overflow: hidden;\n        padding-left: 1.5em;\n        max-height: 0;\n        -webkit-transition-property: max-height;\n        -moz-transition-property: max-height;\n        -ms-transition-property: max-height;\n        -o-transition-property: max-height;\n        transition-property: max-height;\n        -moz-transition-duration: 0.4s;\n        -webkit-transition-duration: 0.4s;\n        -o-transition-duration: 0.4s;\n        transition-duration: 0.4s;\n        -webkit-transition-timing-function: cubic-bezier(0.86, 0, 0.07, 1);\n        -moz-transition-timing-function: cubic-bezier(0.86, 0, 0.07, 1);\n        -o-transition-timing-function: cubic-bezier(0.86, 0, 0.07, 1);\n        transition-timing-function: cubic-bezier(0.86, 0, 0.07, 1); }\n        .layout-wrapper .layout-sidebar ul li ul li a {\n          cursor: pointer;\n          padding: .75em 33px .75em .75em;\n          font-size: 13px;\n          border-top: 0 none; }\n        .layout-wrapper .layout-sidebar ul li ul li:last-child > a {\n          border-bottom: 0 none; }\n      .layout-wrapper .layout-sidebar ul .menuitem-toggle-icon {\n        float: right;\n        margin-top: 2px; }\n      .layout-wrapper .layout-sidebar ul .menuitem-badge {\n        margin-top: 3px;\n        font-size: 10px;\n        float: right;\n        width: 16px;\n        height: 16px;\n        line-height: 16px;\n        text-align: center;\n        color: #ffffff;\n        background-color: #007be5;\n        -moz-border-radius: 50%;\n        -webkit-border-radius: 50%;\n        border-radius: 50%; }\n    .layout-wrapper .layout-sidebar.layout-sidebar-dark {\n      background: #10497F;\n      /* Old browsers */\n      background: -moz-linear-gradient(top, #10497F 0%, #10497F 100%);\n      /* FF3.6+ */\n      background: -webkit-gradient(linear, left top, left bottom, color-stop(0%, #10497F), color-stop(100%, #10497F));\n      /* Chrome,Safari4+ */\n      background: -webkit-linear-gradient(top, #10497F 0%, #10497F 100%);\n      /* Chrome10+,Safari5.1+ */\n      background: -o-linear-gradient(top, #10497F 0%, #10497F 100%);\n      /* Opera 11.10+ */\n      background: -ms-linear-gradient(top, #10497F 0%, #10497F 100%);\n      /* IE10+ */\n      background: linear-gradient(to bottom, #10497F 0%, #10497F 100%);\n      /* W3C */\n      filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#ffffff', endColorstr='#000000',GradientType=0 );\n      /* IE6-9 */ }\n      .layout-wrapper .layout-sidebar.layout-sidebar-dark .profile > button {\n        color: #ffffff; }\n        .layout-wrapper .layout-sidebar.layout-sidebar-dark .profile > button:hover {\n          color: #F0AD4E; }\n      .layout-wrapper .layout-sidebar.layout-sidebar-dark .profile > ul {\n        background-color: #6D9BC7; }\n        .layout-wrapper .layout-sidebar.layout-sidebar-dark .profile > ul li button {\n          border: 0 none;\n          color: #ffffff;\n          border-top: 1px solid rgba(52, 56, 65, 0.6); }\n          .layout-wrapper .layout-sidebar.layout-sidebar-dark .profile > ul li button:hover {\n            color: #F0AD4E; }\n      .layout-wrapper .layout-sidebar.layout-sidebar-dark ul li a {\n        color: #ffffff;\n        border-top: 1px solid rgba(52, 56, 65, 0.6); }\n        .layout-wrapper .layout-sidebar.layout-sidebar-dark ul li a:hover {\n          color: #F0AD4E; }\n        .layout-wrapper .layout-sidebar.layout-sidebar-dark ul li a.active-route {\n          background-color: #597FA2;\n          color: #F0AD4E; }\n      .layout-wrapper .layout-sidebar.layout-sidebar-dark ul li.active-menuitem > a {\n        background-color: #6D9BC7;\n        color: #F0AD4E; }\n      .layout-wrapper .layout-sidebar.layout-sidebar-dark ul li ul {\n        background-color: #597FA2; }\n        .layout-wrapper .layout-sidebar.layout-sidebar-dark ul li ul li a {\n          border: none; }\n        .layout-wrapper .layout-sidebar.layout-sidebar-dark ul li ul li.active-menuitem > a {\n          background-color: #597FA2;\n          color: #F0AD4E; }\n  .layout-wrapper .layout-main {\n    -moz-transition: margin-left 0.2s;\n    -o-transition: margin-left 0.2s;\n    -webkit-transition: margin-left 0.2s;\n    transition: margin-left 0.2s;\n    padding: 66px 16px 16px 16px; }\n  .layout-wrapper .layout-footer {\n    -moz-transition: margin-left 0.2s;\n    -o-transition: margin-left 0.2s;\n    -webkit-transition: margin-left 0.2s;\n    transition: margin-left 0.2s;\n    background-color: #ffffff;\n    padding: 1em 2em; }\n    .layout-wrapper .layout-footer img {\n      vertical-align: middle; }\n    .layout-wrapper .layout-footer .footer-text {\n      vertical-align: middle; }\n\n/* Responsive */\n@media (min-width: 1025px) {\n  .layout-wrapper.layout-overlay .layout-sidebar {\n    left: -250px; }\n  .layout-wrapper.layout-overlay .layout-topbar {\n    left: 0; }\n  .layout-wrapper.layout-overlay .layout-main, .layout-wrapper.layout-overlay .layout-footer {\n    margin-left: 0; }\n  .layout-wrapper.layout-overlay.layout-overlay-sidebar-active .layout-sidebar {\n    left: 0; }\n  .layout-wrapper.layout-overlay.layout-overlay-sidebar-active .layout-topbar {\n    left: 250px; }\n  .layout-wrapper.layout-static .layout-sidebar {\n    left: 0; }\n  .layout-wrapper.layout-static .layout-topbar {\n    left: 250px; }\n  .layout-wrapper.layout-static .layout-main, .layout-wrapper.layout-static .layout-footer {\n    margin-left: 250px; }\n  .layout-wrapper.layout-static.layout-static-sidebar-inactive .layout-sidebar {\n    left: -250px; }\n  .layout-wrapper.layout-static.layout-static-sidebar-inactive .layout-topbar {\n    left: 0; }\n  .layout-wrapper.layout-static.layout-static-sidebar-inactive .layout-main, .layout-wrapper.layout-static.layout-static-sidebar-inactive .layout-footer {\n    margin-left: 0; } }\n\n@media (max-width: 1024px) {\n  .layout-wrapper .layout-topbar {\n    left: 0; }\n  .layout-wrapper .layout-main, .layout-wrapper .layout-footer {\n    margin-left: 0; }\n  .layout-wrapper .layout-sidebar {\n    left: -250px;\n    margin-top: 50px; }\n  .layout-wrapper .layout-mask {\n    display: none;\n    position: fixed;\n    width: 100%;\n    height: 100%;\n    top: 50px;\n    left: 0;\n    z-index: 998;\n    background-color: #424242;\n    opacity: 0.7;\n    filter: alpha(opacity=70); }\n  .layout-wrapper.layout-mobile-sidebar-active .layout-sidebar {\n    left: -0; }\n  .layout-wrapper.layout-mobile-sidebar-active .layout-mask {\n    display: block; }\n  .body-overflow-hidden {\n    overflow: hidden; } }\n\n/* Typography */\nh1 {\n  font-weight: normal;\n  margin: 0;\n  font-size: 24px; }\n\nh2 {\n  font-size: 20px;\n  font-weight: normal;\n  margin: 0; }\n\n.card {\n  background-color: #ffffff;\n  padding: 1em;\n  margin-bottom: 16px;\n  -moz-border-radius: 3px;\n  -webkit-border-radius: 3px;\n  border-radius: 3px; }\n  .card.card-w-title {\n    padding-bottom: 2em; }\n  .card h1 {\n    margin: .5em 0 .5em 0;\n    border-bottom: 1px solid #d5d5d5;\n    padding: .1em;\n    font-size: 24px; }\n    .card h1:first-child {\n      margin: 0 0 .5em 0; }\n\n.p-g {\n  -ms-flex-wrap: wrap; }\n\n/* Dashboard */\n.dashboard .summary {\n  position: relative;\n  flex-direction: row; }\n  .dashboard .summary .title {\n    font-size: 34px;\n    font-weight: 700;\n    text-align: center; }\n  .dashboard .summary .detail {\n    color: #707070;\n    display: block;\n    margin-top: 5px; }\n  .dashboard .summary .count {\n    top: 30px;\n    right: 10px;\n    font-size: 24px;\n    text-align: center; }\n    .dashboard .summary .count .detail {\n      color: #ffffff;\n      padding: 7px 14px;\n      -moz-border-radius: 3px;\n      -webkit-border-radius: 3px;\n      border-radius: 3px; }\n    .dashboard .summary .count .trust1 {\n      background-color: #5CB85C; }\n    .dashboard .summary .count .over65 {\n      background-color: #10497F; }\n    .dashboard .summary .count .friends {\n      background-color: #F0AD4E; }\n\n.dashboard .highlight-box {\n  height: 100px; }\n  .dashboard .highlight-box:after {\n    content: \"\";\n    display: table;\n    clear: both; }\n  .dashboard .highlight-box .initials {\n    height: 100%;\n    float: left;\n    width: 50%;\n    text-align: center;\n    padding: 1em; }\n    .dashboard .highlight-box .initials > span {\n      font-size: 48px; }\n  .dashboard .highlight-box .highlight-details {\n    height: 100%;\n    background-color: #ffffff;\n    float: left;\n    width: 50%;\n    padding: 1em; }\n    .dashboard .highlight-box .highlight-details i {\n      font-size: 24px;\n      vertical-align: middle;\n      margin-right: .25em; }\n    .dashboard .highlight-box .highlight-details .count {\n      color: #707070;\n      font-size: 36px;\n      display: block; }\n\n.dashboard .task-list {\n  list-style-type: none;\n  margin: 0;\n  padding: 0; }\n  .dashboard .task-list li {\n    padding: .5em .25em;\n    border-bottom: 1px solid #e3e3e3; }\n    .dashboard .task-list li:after {\n      content: \"\";\n      display: table;\n      clear: both; }\n  .dashboard .task-list .p-checkbox {\n    vertical-align: middle;\n    margin-right: .5em; }\n  .dashboard .task-list .task-name {\n    vertical-align: middle; }\n  .dashboard .task-list .p-button {\n    float: right; }\n    .dashboard .task-list .p-button .p-button-text {\n      padding: .125em; }\n  .dashboard .task-list .p-panel-content {\n    min-height: 256px; }\n\n.dashboard .contact-form .p-panel-content {\n  min-height: 256px; }\n\n.dashboard .contacts ul {\n  list-style-type: none;\n  padding: 0;\n  margin: 0; }\n  .dashboard .contacts ul li {\n    border-bottom: 1px solid #e3e3e3; }\n    .dashboard .contacts ul li button {\n      padding: 9px;\n      width: 100%;\n      box-sizing: border-box;\n      text-decoration: none;\n      position: relative;\n      display: block;\n      -moz-border-radius: 2px;\n      -webkit-border-radius: 2px;\n      border-radius: 2px;\n      -moz-transition: background-color 0.2s;\n      -o-transition: background-color 0.2s;\n      -webkit-transition: background-color 0.2s;\n      transition: background-color 0.2s; }\n      .dashboard .contacts ul li button .name {\n        position: absolute;\n        right: 10px;\n        top: 10px;\n        font-size: 18px; }\n      .dashboard .contacts ul li button .email {\n        position: absolute;\n        right: 10px;\n        top: 30px;\n        font-size: 14px;\n        color: #707070; }\n      .dashboard .contacts ul li button:hover {\n        cursor: pointer;\n        background-color: #eeeeee; }\n    .dashboard .contacts ul li:last-child {\n      border: 0; }\n\n.dashboard .contacts .p-panel-content {\n  min-height: 256px; }\n\n.dashboard .activity-list {\n  list-style-type: none;\n  padding: 0;\n  margin: 0; }\n  .dashboard .activity-list li {\n    border-bottom: 1px solid #e3e3e3;\n    padding: 16px 8px; }\n    .dashboard .activity-list li .count {\n      font-size: 24px;\n      color: #ffffff;\n      background-color: #007be5;\n      font-weight: 700;\n      display: inline-block;\n      padding: .25em .5em;\n      -moz-border-radius: 3px;\n      -webkit-border-radius: 3px;\n      border-radius: 3px; }\n    .dashboard .activity-list li:first-child {\n      border-top: 1px solid #e3e3e3; }\n    .dashboard .activity-list li:last-child {\n      border: 0; }\n    .dashboard .activity-list li .p-g-6:first-child {\n      font-size: 18px;\n      padding-left: 0; }\n    .dashboard .activity-list li .p-g-6:last-child {\n      text-align: right;\n      color: #707070; }\n\n/*!\n * Quill Editor v1.0.0-beta.3\n * https://quilljs.com/\n * Copyright (c) 2014, Jason Chen\n * Copyright (c) 2013, salesforce.com\n */\n.ql-container {\n  box-sizing: border-box;\n  font-family: Helvetica, Arial, sans-serif;\n  font-size: 13px;\n  height: 100%;\n  margin: 0px;\n  position: relative; }\n\n.ql-clipboard {\n  left: -100000px;\n  position: absolute;\n  top: 50%; }\n\n.ql-clipboard p {\n  margin: 0;\n  padding: 0; }\n\n.ql-editor {\n  box-sizing: border-box;\n  cursor: text;\n  line-height: 1.42;\n  height: 100%;\n  outline: none;\n  overflow-y: auto;\n  padding: 12px 15px;\n  tab-size: 4;\n  text-align: left;\n  white-space: pre-wrap; }\n\n.ql-editor p,\n.ql-editor ol,\n.ql-editor ul,\n.ql-editor pre,\n.ql-editor blockquote,\n.ql-editor h1,\n.ql-editor h2,\n.ql-editor h3,\n.ql-editor h4,\n.ql-editor h5,\n.ql-editor h6 {\n  margin: 0;\n  padding: 0;\n  counter-reset: list-1 list-2 list-3 list-4 list-5 list-6 list-7 list-8; }\n\n.ql-editor ol {\n  padding-left: 20px; }\n\n.ql-editor ul {\n  padding-left: 8px;\n  list-style: disc inside; }\n\n.ql-editor ol > li {\n  list-style-type: none; }\n\n.ql-editor ol {\n  list-style-type: none;\n  position: relative; }\n\n.ql-editor ol li {\n  counter-reset: list-1 list-2 list-3 list-4 list-5 list-6 list-7 list-8;\n  counter-increment: list-num; }\n\n.ql-editor ol li:before {\n  content: counter(list-num, decimal) \". \";\n  margin-right: -16px;\n  position: absolute;\n  right: 100%;\n  text-align: right; }\n\n.ql-editor ol li.ql-indent-1 {\n  counter-increment: list-1; }\n\n.ql-editor ol li.ql-indent-1:before {\n  content: counter(list-1, lower-alpha) \". \";\n  margin-right: -56px; }\n\n.ql-editor ol li.ql-indent-1 {\n  counter-reset: list-2 list-3 list-4 list-5 list-6 list-7 list-8; }\n\n.ql-editor ol li.ql-indent-2 {\n  counter-increment: list-2; }\n\n.ql-editor ol li.ql-indent-2:before {\n  content: counter(list-2, lower-roman) \". \";\n  margin-right: -96px; }\n\n.ql-editor ol li.ql-indent-2 {\n  counter-reset: list-3 list-4 list-5 list-6 list-7 list-8; }\n\n.ql-editor ol li.ql-indent-3 {\n  counter-increment: list-3; }\n\n.ql-editor ol li.ql-indent-3:before {\n  content: counter(list-3, decimal) \". \";\n  margin-right: -136px; }\n\n.ql-editor ol li.ql-indent-3 {\n  counter-reset: list-4 list-5 list-6 list-7 list-8; }\n\n.ql-editor ol li.ql-indent-4 {\n  counter-increment: list-4; }\n\n.ql-editor ol li.ql-indent-4:before {\n  content: counter(list-4, lower-alpha) \". \";\n  margin-right: -176px; }\n\n.ql-editor ol li.ql-indent-4 {\n  counter-reset: list-5 list-6 list-7 list-8; }\n\n.ql-editor ol li.ql-indent-5 {\n  counter-increment: list-5; }\n\n.ql-editor ol li.ql-indent-5:before {\n  content: counter(list-5, lower-roman) \". \";\n  margin-right: -216px; }\n\n.ql-editor ol li.ql-indent-5 {\n  counter-reset: list-6 list-7 list-8; }\n\n.ql-editor ol li.ql-indent-6 {\n  counter-increment: list-6; }\n\n.ql-editor ol li.ql-indent-6:before {\n  content: counter(list-6, decimal) \". \";\n  margin-right: -256px; }\n\n.ql-editor ol li.ql-indent-6 {\n  counter-reset: list-7 list-8; }\n\n.ql-editor ol li.ql-indent-7 {\n  counter-increment: list-7; }\n\n.ql-editor ol li.ql-indent-7:before {\n  content: counter(list-7, lower-alpha) \". \";\n  margin-right: -296px; }\n\n.ql-editor ol li.ql-indent-7 {\n  counter-reset: list-8; }\n\n.ql-editor ol li.ql-indent-8 {\n  counter-increment: list-8; }\n\n.ql-editor ol li.ql-indent-8:before {\n  content: counter(list-8, lower-roman) \". \";\n  margin-right: -336px; }\n\n.ql-editor .ql-indent-1 {\n  padding-left: 40px; }\n\n.ql-editor .ql-indent-2 {\n  padding-left: 80px; }\n\n.ql-editor .ql-indent-3 {\n  padding-left: 120px; }\n\n.ql-editor .ql-indent-4 {\n  padding-left: 160px; }\n\n.ql-editor .ql-indent-5 {\n  padding-left: 200px; }\n\n.ql-editor .ql-indent-6 {\n  padding-left: 240px; }\n\n.ql-editor .ql-indent-7 {\n  padding-left: 280px; }\n\n.ql-editor .ql-indent-8 {\n  padding-left: 320px; }\n\n.ql-editor .ql-video {\n  display: block; }\n\n.ql-editor .ql-video.ql-align-center {\n  margin: 0 auto; }\n\n.ql-editor .ql-video.ql-align-right {\n  margin: 0 0 0 auto; }\n\n.ql-editor .ql-bg-black {\n  background-color: #000; }\n\n.ql-editor .ql-bg-red {\n  background-color: #e60000; }\n\n.ql-editor .ql-bg-orange {\n  background-color: #f90; }\n\n.ql-editor .ql-bg-yellow {\n  background-color: #ff0; }\n\n.ql-editor .ql-bg-green {\n  background-color: #008a00; }\n\n.ql-editor .ql-bg-blue {\n  background-color: #06c; }\n\n.ql-editor .ql-bg-purple {\n  background-color: #93f; }\n\n.ql-editor .ql-color-white {\n  color: #fff; }\n\n.ql-editor .ql-color-red {\n  color: #e60000; }\n\n.ql-editor .ql-color-orange {\n  color: #f90; }\n\n.ql-editor .ql-color-yellow {\n  color: #ff0; }\n\n.ql-editor .ql-color-green {\n  color: #008a00; }\n\n.ql-editor .ql-color-blue {\n  color: #06c; }\n\n.ql-editor .ql-color-purple {\n  color: #93f; }\n\n.ql-editor .ql-font-serif {\n  font-family: Georgia, Times New Roman, serif; }\n\n.ql-editor .ql-font-monospace {\n  font-family: Monaco, Courier New, monospace; }\n\n.ql-editor .ql-size-small {\n  font-size: 10px; }\n\n.ql-editor .ql-size-large {\n  font-size: 18px; }\n\n.ql-editor .ql-size-huge {\n  font-size: 32px; }\n\n.ql-editor .ql-direction-rtl {\n  direction: rtl;\n  text-align: inherit; }\n\n.ql-editor .ql-align-center {\n  text-align: center; }\n\n.ql-editor .ql-align-justify {\n  text-align: justify; }\n\n.ql-editor .ql-align-right {\n  text-align: right; }\n\n.ql-editor.ql-blank::before {\n  color: rgba(0, 0, 0, 0.6);\n  content: attr(data-placeholder);\n  font-style: italic;\n  pointer-events: none;\n  position: absolute; }\n\n.ql-hidden {\n  display: none; }\n\n.ql-tooltip {\n  position: absolute; }\n\n.ql-tooltip a {\n  cursor: pointer;\n  text-decoration: none; }\n\n.ql-toolbar:before,\n.ql-toolbar:after {\n  content: ' ';\n  display: table; }\n\n.ql-toolbar:after {\n  clear: both; }\n\n.ql-toolbar button {\n  background: none;\n  border: none;\n  cursor: pointer;\n  display: inline-block;\n  float: left;\n  height: 24px;\n  outline: none;\n  padding: 3px 5px;\n  width: 24px; }\n\n.ql-toolbar button svg {\n  height: 100%; }\n\n.ql-toolbar .ql-stroke {\n  fill: none;\n  stroke-linecap: round;\n  stroke-linejoin: round;\n  stroke-width: 2; }\n\n.ql-toolbar .ql-stroke-mitter {\n  fill: none;\n  stroke-mitterlimit: 10;\n  stroke-width: 2; }\n\n.ql-toolbar .ql-empty {\n  fill: none; }\n\n.ql-toolbar .ql-even {\n  fill-rule: evenodd; }\n\n.ql-toolbar .ql-thin,\n.ql-toolbar .ql-stroke.ql-thin {\n  stroke-width: 1; }\n\n.ql-toolbar .ql-transparent {\n  opacity: 0.4; }\n\n.ql-editor h1 {\n  font-size: 2em; }\n\n.ql-editor h2 {\n  font-size: 1.5em; }\n\n.ql-editor h3 {\n  font-size: 1.17em; }\n\n.ql-editor h4 {\n  font-size: 1em; }\n\n.ql-editor h5 {\n  font-size: 0.83em; }\n\n.ql-editor h6 {\n  font-size: 0.67em; }\n\n.ql-editor pre {\n  white-space: pre-wrap; }\n\n.ql-editor a {\n  text-decoration: underline; }\n\n.ql-editor blockquote {\n  border-left: 4px solid #ccc;\n  margin-bottom: 5px;\n  margin-top: 5px;\n  padding-left: 16px; }\n\n.ql-editor pre.hljs {\n  overflow: visible; }\n\n.ql-editor code,\n.ql-editor pre:not(.hljs) {\n  background-color: #f0f0f0; }\n\n.ql-editor code,\n.ql-editor pre {\n  border-radius: 3px; }\n\n.ql-editor code {\n  font-size: 85%;\n  padding-bottom: 2px;\n  padding-top: 2px; }\n\n.ql-editor code:before,\n.ql-editor code:after {\n  content: \"\\A0\";\n  letter-spacing: -2px; }\n\n.ql-editor *:not(pre) + pre,\n.ql-editor pre:first-of-type {\n  margin-top: 5px;\n  padding-top: 5px; }\n\n.ql-editor pre {\n  margin-bottom: 5px;\n  padding: 0px 10px 5px; }\n\n.ql-editor pre + pre {\n  margin-top: -10px; }\n\n.ql-editor img {\n  max-width: 100%; }\n\n.ql-snow .ql-image-tooltip {\n  padding: 10px;\n  text-align: center;\n  width: 300px; }\n\n.ql-snow .ql-image-tooltip input[type=text] {\n  height: 30px;\n  width: 100%; }\n\n.ql-snow .ql-image-tooltip a.ql-cancel,\n.ql-snow .ql-image-tooltip a.ql-action {\n  border: 1px solid #06c;\n  display: inline-block;\n  float: left;\n  line-height: 18px;\n  padding: 5px;\n  width: 50%; }\n\n.ql-snow .ql-image-tooltip a.ql-cancel::before {\n  color: #06c;\n  content: 'Cancel'; }\n\n.ql-snow .ql-image-tooltip a.ql-action {\n  background-color: #06c; }\n\n.ql-snow .ql-image-tooltip a.ql-action::before {\n  color: #fff;\n  content: 'Insert'; }\n\n.ql-snow .ql-image-tooltip .ql-preview {\n  height: 200px;\n  margin: 10px 0px;\n  position: relative; }\n\n.ql-snow .ql-image-tooltip .ql-preview img {\n  bottom: 0;\n  left: 0;\n  margin: auto;\n  max-height: 100%;\n  max-width: 100%;\n  position: absolute;\n  right: 0;\n  top: 0; }\n\n.ql-snow .ql-image-tooltip .ql-empty.ql-preview::before {\n  border: 1px dashed #ccc;\n  color: #ccc;\n  content: 'Preview';\n  display: block;\n  line-height: 200px; }\n\n.ql-snow .ql-link-tooltip::before {\n  content: \"Visit URL:\";\n  line-height: 26px;\n  margin-right: 8px; }\n\n.ql-snow .ql-link-tooltip {\n  margin-top: 10px;\n  padding: 5px 12px;\n  white-space: nowrap; }\n\n.ql-snow .ql-link-tooltip input[type=text] {\n  display: none;\n  height: 26px;\n  width: 170px; }\n\n.ql-snow .ql-link-tooltip a.ql-preview {\n  display: inline-block;\n  max-width: 200px;\n  overflow-x: hidden;\n  text-overflow: ellipsis;\n  vertical-align: top; }\n\n.ql-snow .ql-link-tooltip a.ql-action::before {\n  color: #444;\n  content: '-';\n  line-height: 26px;\n  margin-left: 8px; }\n\n.ql-snow .ql-link-tooltip a.ql-action::after {\n  border-right: 1px solid #ccc;\n  content: 'Edit';\n  margin-left: 8px;\n  padding-right: 8px; }\n\n.ql-snow .ql-link-tooltip a.ql-remove::before {\n  content: 'Remove';\n  margin-left: 8px; }\n\n.ql-snow .ql-link-tooltip a {\n  line-height: 26px; }\n\n.ql-snow .ql-link-tooltip.ql-editing a.ql-preview,\n.ql-snow .ql-link-tooltip.ql-editing a.ql-remove {\n  display: none; }\n\n.ql-snow .ql-link-tooltip.ql-editing input[type=text] {\n  display: inline-block; }\n\n.ql-snow .ql-link-tooltip.ql-editing a.ql-action::after {\n  border-right: 0px;\n  content: 'Save';\n  padding-right: 0px; }\n\n.ql-toolbar.ql-snow {\n  border: 1px solid #ccc;\n  box-sizing: border-box;\n  font-family: 'Helvetica Neue', 'Helvetica', 'Arial', sans-serif;\n  padding: 8px; }\n\n.ql-toolbar.ql-snow * {\n  box-sizing: border-box; }\n\n.ql-toolbar.ql-snow .ql-formats {\n  display: inline-block;\n  margin-right: 15px;\n  vertical-align: middle; }\n\n.ql-toolbar.ql-snow button:hover,\n.ql-toolbar.ql-snow button.ql-active,\n.ql-toolbar.ql-snow .ql-picker-label:hover,\n.ql-toolbar.ql-snow .ql-picker-label.ql-active,\n.ql-toolbar.ql-snow .ql-picker-item:hover,\n.ql-toolbar.ql-snow .ql-picker-item.ql-selected {\n  color: #06c; }\n\n.ql-toolbar.ql-snow button:hover .ql-fill,\n.ql-toolbar.ql-snow button.ql-active .ql-fill,\n.ql-toolbar.ql-snow .ql-picker-label:hover .ql-fill,\n.ql-toolbar.ql-snow .ql-picker-label.ql-active .ql-fill,\n.ql-toolbar.ql-snow .ql-picker-item:hover .ql-fill,\n.ql-toolbar.ql-snow .ql-picker-item.ql-selected .ql-fill,\n.ql-toolbar.ql-snow button:hover .ql-stroke.ql-fill,\n.ql-toolbar.ql-snow button.ql-active .ql-stroke.ql-fill,\n.ql-toolbar.ql-snow .ql-picker-label:hover .ql-stroke.ql-fill,\n.ql-toolbar.ql-snow .ql-picker-label.ql-active .ql-stroke.ql-fill,\n.ql-toolbar.ql-snow .ql-picker-item:hover .ql-stroke.ql-fill,\n.ql-toolbar.ql-snow .ql-picker-item.ql-selected .ql-stroke.ql-fill {\n  fill: #06c; }\n\n.ql-toolbar.ql-snow button:hover .ql-stroke,\n.ql-toolbar.ql-snow button.ql-active .ql-stroke,\n.ql-toolbar.ql-snow .ql-picker-label:hover .ql-stroke,\n.ql-toolbar.ql-snow .ql-picker-label.ql-active .ql-stroke,\n.ql-toolbar.ql-snow .ql-picker-item:hover .ql-stroke,\n.ql-toolbar.ql-snow .ql-picker-item.ql-selected .ql-stroke,\n.ql-toolbar.ql-snow button:hover .ql-stroke-mitter,\n.ql-toolbar.ql-snow button.ql-active .ql-stroke-mitter,\n.ql-toolbar.ql-snow .ql-picker-label:hover .ql-stroke-mitter,\n.ql-toolbar.ql-snow .ql-picker-label.ql-active .ql-stroke-mitter,\n.ql-toolbar.ql-snow .ql-picker-item:hover .ql-stroke-mitter,\n.ql-toolbar.ql-snow .ql-picker-item.ql-selected .ql-stroke-mitter {\n  stroke: #06c; }\n\n.ql-toolbar.ql-snow .ql-stroke {\n  stroke: #444; }\n\n.ql-toolbar.ql-snow .ql-stroke-mitter {\n  stroke: #444; }\n\n.ql-toolbar.ql-snow .ql-fill,\n.ql-toolbar.ql-snow .ql-stroke.ql-fill {\n  fill: #444; }\n\n.ql-toolbar.ql-snow .ql-direction svg:last-child {\n  display: none; }\n\n.ql-toolbar.ql-snow .ql-direction.ql-active svg:last-child {\n  display: inline; }\n\n.ql-toolbar.ql-snow .ql-direction.ql-active svg:first-child {\n  display: none; }\n\n.ql-toolbar.ql-snow .ql-picker {\n  color: #444;\n  display: inline-block;\n  float: left;\n  font-size: 14px;\n  font-weight: 500;\n  height: 24px;\n  position: relative;\n  vertical-align: middle; }\n\n.ql-toolbar.ql-snow .ql-picker-label {\n  border: 1px solid transparent;\n  cursor: pointer;\n  display: inline-block;\n  height: 100%;\n  padding-left: 8px;\n  padding-right: 2px;\n  position: relative;\n  width: 100%; }\n\n.ql-toolbar.ql-snow .ql-picker-label svg {\n  float: right;\n  height: 18px;\n  margin-top: 2px;\n  width: 18px; }\n\n.ql-toolbar.ql-snow .ql-picker-label::before {\n  vertical-align: middle; }\n\n.ql-toolbar.ql-snow .ql-picker-options {\n  background-color: #fff;\n  border: 1px solid transparent;\n  display: none;\n  min-width: 100%;\n  padding: 4px 8px;\n  position: absolute;\n  white-space: nowrap; }\n\n.ql-toolbar.ql-snow .ql-picker-options .ql-picker-item {\n  cursor: pointer;\n  display: block;\n  padding-bottom: 5px;\n  padding-top: 5px; }\n\n.ql-toolbar.ql-snow .ql-picker.ql-expanded .ql-picker-label {\n  border-color: #ccc;\n  color: #ccc;\n  z-index: 2; }\n\n.ql-toolbar.ql-snow .ql-picker.ql-expanded .ql-picker-label .ql-fill {\n  fill: #ccc; }\n\n.ql-toolbar.ql-snow .ql-picker.ql-expanded .ql-picker-label .ql-stroke {\n  stroke: #ccc; }\n\n.ql-toolbar.ql-snow .ql-picker.ql-expanded .ql-picker-options {\n  border-color: #ccc;\n  box-shadow: rgba(0, 0, 0, 0.2) 0 2px 8px;\n  display: block;\n  margin-top: -1px;\n  z-index: 1; }\n\n.ql-toolbar.ql-snow .ql-color-picker,\n.ql-toolbar.ql-snow .ql-icon-picker {\n  width: 28px; }\n\n.ql-toolbar.ql-snow .ql-color-picker .ql-picker-label,\n.ql-toolbar.ql-snow .ql-icon-picker .ql-picker-label {\n  padding: 2px 4px; }\n\n.ql-toolbar.ql-snow .ql-color-picker .ql-picker-label svg,\n.ql-toolbar.ql-snow .ql-icon-picker .ql-picker-label svg {\n  margin-top: 0px; }\n\n.ql-toolbar.ql-snow .ql-icon-picker .ql-picker-options {\n  padding: 4px 0px; }\n\n.ql-toolbar.ql-snow .ql-icon-picker .ql-picker-item {\n  height: 24px;\n  padding: 2px 4px; }\n\n.ql-toolbar.ql-snow .ql-color-picker.ql-expanded .ql-picker-options,\n.ql-toolbar.ql-snow .ql-icon-picker.ql-expanded .ql-picker-options {\n  margin-top: -6px; }\n\n.ql-toolbar.ql-snow .ql-color-picker .ql-picker-options {\n  padding: 5px;\n  width: 152px; }\n\n.ql-toolbar.ql-snow .ql-color-picker .ql-picker-item {\n  border: 1px solid transparent;\n  float: left;\n  height: 16px;\n  margin: 2px;\n  padding: 0px;\n  width: 16px; }\n\n.ql-toolbar.ql-snow .ql-color-picker .ql-picker-item.ql-primary-color {\n  margin-bottom: toolbarPadding; }\n\n.ql-toolbar.ql-snow .ql-color-picker .ql-picker-item.ql-selected,\n.ql-toolbar.ql-snow .ql-color-picker .ql-picker-item:hover {\n  border-color: #000; }\n\n.ql-toolbar.ql-snow .ql-picker.ql-header .ql-picker-label[data-label]:not([data-label=''])::before,\n.ql-toolbar.ql-snow .ql-picker.ql-font .ql-picker-label[data-label]:not([data-label=''])::before,\n.ql-toolbar.ql-snow .ql-picker.ql-size .ql-picker-label[data-label]:not([data-label=''])::before,\n.ql-toolbar.ql-snow .ql-picker.ql-header .ql-picker-item[data-label]:not([data-label=''])::before,\n.ql-toolbar.ql-snow .ql-picker.ql-font .ql-picker-item[data-label]:not([data-label=''])::before,\n.ql-toolbar.ql-snow .ql-picker.ql-size .ql-picker-item[data-label]:not([data-label=''])::before {\n  content: attr(data-label); }\n\n.ql-toolbar.ql-snow .ql-picker.ql-header {\n  width: 98px; }\n\n.ql-toolbar.ql-snow .ql-picker.ql-header .ql-picker-label::before,\n.ql-toolbar.ql-snow .ql-picker.ql-header .ql-picker-item::before {\n  content: 'Normal'; }\n\n.ql-toolbar.ql-snow .ql-picker.ql-header .ql-picker-label[data-value=\"1\"]::before,\n.ql-toolbar.ql-snow .ql-picker.ql-header .ql-picker-item[data-value=\"1\"]::before {\n  content: 'Heading 1'; }\n\n.ql-toolbar.ql-snow .ql-picker.ql-header .ql-picker-label[data-value=\"2\"]::before,\n.ql-toolbar.ql-snow .ql-picker.ql-header .ql-picker-item[data-value=\"2\"]::before {\n  content: 'Heading 2'; }\n\n.ql-toolbar.ql-snow .ql-picker.ql-header .ql-picker-label[data-value=\"3\"]::before,\n.ql-toolbar.ql-snow .ql-picker.ql-header .ql-picker-item[data-value=\"3\"]::before {\n  content: 'Heading 3'; }\n\n.ql-toolbar.ql-snow .ql-picker.ql-header .ql-picker-label[data-value=\"4\"]::before,\n.ql-toolbar.ql-snow .ql-picker.ql-header .ql-picker-item[data-value=\"4\"]::before {\n  content: 'Heading 4'; }\n\n.ql-toolbar.ql-snow .ql-picker.ql-header .ql-picker-label[data-value=\"5\"]::before,\n.ql-toolbar.ql-snow .ql-picker.ql-header .ql-picker-item[data-value=\"5\"]::before {\n  content: 'Heading 5'; }\n\n.ql-toolbar.ql-snow .ql-picker.ql-header .ql-picker-label[data-value=\"6\"]::before,\n.ql-toolbar.ql-snow .ql-picker.ql-header .ql-picker-item[data-value=\"6\"]::before {\n  content: 'Heading 6'; }\n\n.ql-toolbar.ql-snow .ql-picker.ql-header .ql-picker-item[data-value=\"1\"]::before {\n  font-size: 2em; }\n\n.ql-toolbar.ql-snow .ql-picker.ql-header .ql-picker-item[data-value=\"2\"]::before {\n  font-size: 1.5em; }\n\n.ql-toolbar.ql-snow .ql-picker.ql-header .ql-picker-item[data-value=\"3\"]::before {\n  font-size: 1.17em; }\n\n.ql-toolbar.ql-snow .ql-picker.ql-header .ql-picker-item[data-value=\"4\"]::before {\n  font-size: 1em; }\n\n.ql-toolbar.ql-snow .ql-picker.ql-header .ql-picker-item[data-value=\"5\"]::before {\n  font-size: 0.83em; }\n\n.ql-toolbar.ql-snow .ql-picker.ql-header .ql-picker-item[data-value=\"6\"]::before {\n  font-size: 0.67em; }\n\n.ql-toolbar.ql-snow .ql-picker.ql-font {\n  width: 108px; }\n\n.ql-toolbar.ql-snow .ql-picker.ql-font .ql-picker-label::before,\n.ql-toolbar.ql-snow .ql-picker.ql-font .ql-picker-item::before {\n  content: 'Sans Serif'; }\n\n.ql-toolbar.ql-snow .ql-picker.ql-font .ql-picker-label[data-value=serif]::before,\n.ql-toolbar.ql-snow .ql-picker.ql-font .ql-picker-item[data-value=serif]::before {\n  content: 'Serif'; }\n\n.ql-toolbar.ql-snow .ql-picker.ql-font .ql-picker-label[data-value=monospace]::before,\n.ql-toolbar.ql-snow .ql-picker.ql-font .ql-picker-item[data-value=monospace]::before {\n  content: 'Monospace'; }\n\n.ql-toolbar.ql-snow .ql-picker.ql-font .ql-picker-item[data-value=serif]::before {\n  font-family: Georgia, Times New Roman, serif; }\n\n.ql-toolbar.ql-snow .ql-picker.ql-font .ql-picker-item[data-value=monospace]::before {\n  font-family: Monaco, Courier New, monospace; }\n\n.ql-toolbar.ql-snow .ql-picker.ql-size {\n  width: 98px; }\n\n.ql-toolbar.ql-snow .ql-picker.ql-size .ql-picker-label::before,\n.ql-toolbar.ql-snow .ql-picker.ql-size .ql-picker-item::before {\n  content: 'Normal'; }\n\n.ql-toolbar.ql-snow .ql-picker.ql-size .ql-picker-label[data-value=small]::before,\n.ql-toolbar.ql-snow .ql-picker.ql-size .ql-picker-item[data-value=small]::before {\n  content: 'Small'; }\n\n.ql-toolbar.ql-snow .ql-picker.ql-size .ql-picker-label[data-value=large]::before,\n.ql-toolbar.ql-snow .ql-picker.ql-size .ql-picker-item[data-value=large]::before {\n  content: 'Large'; }\n\n.ql-toolbar.ql-snow .ql-picker.ql-size .ql-picker-label[data-value=huge]::before,\n.ql-toolbar.ql-snow .ql-picker.ql-size .ql-picker-item[data-value=huge]::before {\n  content: 'Huge'; }\n\n.ql-toolbar.ql-snow .ql-picker.ql-size .ql-picker-item[data-value=small]::before {\n  font-size: 10px; }\n\n.ql-toolbar.ql-snow .ql-picker.ql-size .ql-picker-item[data-value=large]::before {\n  font-size: 18px; }\n\n.ql-toolbar.ql-snow .ql-picker.ql-size .ql-picker-item[data-value=huge]::before {\n  font-size: 32px; }\n\n.ql-toolbar.ql-snow .ql-color-picker.ql-background .ql-picker-item {\n  background-color: #fff; }\n\n.ql-toolbar.ql-snow .ql-color-picker.ql-color .ql-picker-item {\n  background-color: #000; }\n\n.ql-toolbar.ql-snow + .ql-container.ql-snow {\n  border-top: 0px; }\n\n.ql-snow .ql-tooltip {\n  background-color: #fff;\n  border: 1px solid #ccc;\n  box-shadow: 0px 0px 5px #ddd;\n  color: #444; }\n\n.ql-snow .ql-tooltip input[type=text] {\n  border: 1px solid #ccc;\n  font-size: 13px;\n  margin: 0px;\n  padding: 3px 5px; }\n\n.ql-container.ql-snow {\n  border: 1px solid #ccc; }\n\n.ql-container.ql-snow a {\n  color: #06c; }\n\n.ql-container.ql-snow * {\n  box-sizing: border-box; }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
